const teaorList = [
  {
    labelText: `01 '08 Növénytermesztés, állattenyésztés, vadgazdálkodás és kapcsolódó szolgáltatások`,
    teaorValue: '01'
  },
  {
    labelText: `011 '08 Nem évelő növény termesztése`,
    teaorValue: '011'
  },
  {
    labelText: `0111 '08 Gabonaféle (kivéve: rizs), hüvelyes növény, olajos mag termesztése`,
    teaorValue: '0111'
  },
  {
    labelText: `0112 '08 Rizstermesztés`,
    teaorValue: '0112'
  },
  {
    labelText: `0113 '08 Zöldségféle, dinnye, gyökér-, gumósnövény termesztése`,
    teaorValue: '0113'
  },
  {
    labelText: `0114 '08 Cukornádtermesztés`,
    teaorValue: '0114'
  },
  {
    labelText: `0115 '08 Dohánytermesztés`,
    teaorValue: '0115'
  },
  {
    labelText: `0116 '08 Rostnövénytermesztés`,
    teaorValue: '0116'
  },
  {
    labelText: `0119 '08 Egyéb, nem évelő növény termesztése`,
    teaorValue: '0119'
  },
  {
    labelText: `012 '08 Évelő növény termesztése`,
    teaorValue: '012'
  },
  {
    labelText: `0121 '08 Szőlőtermesztés`,
    teaorValue: '0121'
  },
  {
    labelText: `0122 '08 Trópusi gyümölcs termesztése`,
    teaorValue: '0122'
  },
  {
    labelText: `0123 '08 Citrusféle termesztése`,
    teaorValue: '0123'
  },
  {
    labelText: `0124 '08 Almatermésű, csonthéjas termesztése`,
    teaorValue: '0124'
  },
  {
    labelText: `0125 '08 Egyéb gyümölcs, héjastermésű termesztése`,
    teaorValue: '0125'
  },
  {
    labelText: `0126 '08 Olajtartalmú gyümölcs termesztése`,
    teaorValue: '0126'
  },
  {
    labelText: `0127 '08 Italgyártási növény termesztése`,
    teaorValue: '0127'
  },
  {
    labelText: `0128 '08 Fűszer-, aroma-, narkotikus, gyógynövény termesztése`,
    teaorValue: '0128'
  },
  {
    labelText: `0129 '08 Egyéb évelő növény termesztése`,
    teaorValue: '0129'
  },
  {
    labelText: `013 '08 Növényi szaporítóanyag termesztése`,
    teaorValue: '013'
  },
  {
    labelText: `0130 '08 Növényi szaporítóanyag termesztése`,
    teaorValue: '0130'
  },
  {
    labelText: `014 '08 Állattenyésztés`,
    teaorValue: '014'
  },
  {
    labelText: `0141 '08 Tejhasznú szarvasmarha tenyésztése`,
    teaorValue: '0141'
  },
  {
    labelText: `0142 '08 Egyéb szarvasmarha tenyésztése`,
    teaorValue: '0142'
  },
  {
    labelText: `0143 '08 Ló, lóféle tenyésztése`,
    teaorValue: '0143'
  },
  {
    labelText: `0144 '08 Teve, teveféle tenyésztése`,
    teaorValue: '0144'
  },
  {
    labelText: `0145 '08 Juh, kecske tenyésztése`,
    teaorValue: '0145'
  },
  {
    labelText: `0146 '08 Sertéstenyésztés`,
    teaorValue: '0146'
  },
  {
    labelText: `0147 '08 Baromfitenyésztés`,
    teaorValue: '0147'
  },
  {
    labelText: `0149 '08 Egyéb állat tenyésztése`,
    teaorValue: '0149'
  },
  {
    labelText: `015 '08 Vegyes gazdálkodás`,
    teaorValue: '015'
  },
  {
    labelText: `0150 '08 Vegyes gazdálkodás`,
    teaorValue: '0150'
  },
  {
    labelText: `016 '08 Mezőgazdasági, betakarítást követő szolgáltatás`,
    teaorValue: '016'
  },
  {
    labelText: `0161 '08 Növénytermesztési szolgáltatás`,
    teaorValue: '0161'
  },
  {
    labelText: `0162 '08 Állattenyésztési szolgáltatás`,
    teaorValue: '0162'
  },
  {
    labelText: `0163 '08 Betakarítást követő szolgáltatás`,
    teaorValue: '0163'
  },
  {
    labelText: `0164 '08 Vetési célú magfeldolgozás`,
    teaorValue: '0164'
  },
  {
    labelText: `017 '08 Vadgazdálkodás, vadgazdálkodási szolgáltatás`,
    teaorValue: '017'
  },
  {
    labelText: `0170 '08 Vadgazdálkodás, vadgazdálkodási szolgáltatás`,
    teaorValue: '0170'
  },
  {
    labelText: `02 '08 Erdőgazdálkodás`,
    teaorValue: '02'
  },
  {
    labelText: `021 '08 Erdészeti, egyéb erdőgazdálkodási tevékenység`,
    teaorValue: '021'
  },
  {
    labelText: `0210 '08 Erdészeti, egyéb erdőgazdálkodási tevékenység`,
    teaorValue: '0210'
  },
  {
    labelText: `022 '08 Fakitermelés`,
    teaorValue: '022'
  },
  {
    labelText: `0220 '08 Fakitermelés`,
    teaorValue: '0220'
  },
  {
    labelText: `023 '08 Vadon termő egyéb erdei termék gyűjtése`,
    teaorValue: '023'
  },
  {
    labelText: `0230 '08 Vadon termő egyéb erdei termék gyűjtése`,
    teaorValue: '0230'
  },
  {
    labelText: `024 '08 Erdészeti szolgáltatás`,
    teaorValue: '024'
  },
  {
    labelText: `0240 '08 Erdészeti szolgáltatás`,
    teaorValue: '0240'
  },
  {
    labelText: `03 '08 Halászat, halgazdálkodás`,
    teaorValue: '03'
  },
  {
    labelText: `031 '08 Halászat`,
    teaorValue: '031'
  },
  {
    labelText: `0311 '08 Tengeri halászat`,
    teaorValue: '0311'
  },
  {
    labelText: `0312 '08 Édesvízi halászat`,
    teaorValue: '0312'
  },
  {
    labelText: `032 '08 Halgazdálkodás`,
    teaorValue: '032'
  },
  {
    labelText: `0321 '08 Tengerihal-gazdálkodás`,
    teaorValue: '0321'
  },
  {
    labelText: `0322 '08 Édesvízihal-gazdálkodás`,
    teaorValue: '0322'
  },
  {
    labelText: `05 '08 Szénbányászat`,
    teaorValue: '05'
  },
  {
    labelText: `051 '08 Feketeszén-bányászat`,
    teaorValue: '051'
  },
  {
    labelText: `0510 '08 Feketeszén-bányászat`,
    teaorValue: '0510'
  },
  {
    labelText: `052 '08 Barnaszén-, lignitbányászat`,
    teaorValue: '052'
  },
  {
    labelText: `0520 '08 Barnaszén-, lignitbányászat`,
    teaorValue: '0520'
  },
  {
    labelText: `06 '08 Kőolaj-, földgázkitermelés`,
    teaorValue: '06'
  },
  {
    labelText: `061 '08 Kőolaj-kitermelés`,
    teaorValue: '061'
  },
  {
    labelText: `0610 '08 Kőolaj-kitermelés`,
    teaorValue: '0610'
  },
  {
    labelText: `062 '08 Földgázkitermelés`,
    teaorValue: '062'
  },
  {
    labelText: `0620 '08 Földgázkitermelés`,
    teaorValue: '0620'
  },
  {
    labelText: `07 '08 Fémtartalmú érc bányászata`,
    teaorValue: '07'
  },
  {
    labelText: `071 '08 Vasércbányászat`,
    teaorValue: '071'
  },
  {
    labelText: `0710 '08 Vasércbányászat`,
    teaorValue: '0710'
  },
  {
    labelText: `072 '08 Egyéb fém érc bányászata`,
    teaorValue: '072'
  },
  {
    labelText: `0721 '08 Urán-, tóriumérc-bányászat`,
    teaorValue: '0721'
  },
  {
    labelText: `0729 '08 Színesfém érc bányászata`,
    teaorValue: '0729'
  },
  {
    labelText: `08 '08 Egyéb bányászat`,
    teaorValue: '08'
  },
  {
    labelText: `081 '08 Kőfejtés, homok-, agyagbányászat`,
    teaorValue: '081'
  },
  {
    labelText: `0811 '08 Kőfejtés, gipsz, kréta bányászata`,
    teaorValue: '0811'
  },
  {
    labelText: `0812 '08 Kavics-, homok-, agyagbányászat`,
    teaorValue: '0812'
  },
  {
    labelText: `089 '08 M`,
    teaorValue: '089'
  },
  {
    labelText: `0891 '08 Vegyi ásvány bányászata`,
    teaorValue: '0891'
  },
  {
    labelText: `0892 '08 Tőzegkitermelés`,
    teaorValue: '0892'
  },
  {
    labelText: `0893 '08 Sókitermelés`,
    teaorValue: '0893'
  },
  {
    labelText: `0899 '08 Egyéb m`,
    teaorValue: '0899'
  },
  {
    labelText: `09 '08 Bányászati szolgáltatás`,
    teaorValue: '09'
  },
  {
    labelText: `091 '08 Kőolaj-, földgáz-kitermelési szolgáltatás`,
    teaorValue: '091'
  },
  {
    labelText: `0910 '08 Kőolaj-, földgáz-kitermelési szolgáltatás`,
    teaorValue: '0910'
  },
  {
    labelText: `099 '08 Egyéb bányászati szolgáltatás`,
    teaorValue: '099'
  },
  {
    labelText: `0990 '08 Egyéb bányászati szolgáltatás`,
    teaorValue: '0990'
  },
  {
    labelText: `10 '08 Élelmiszergyártás`,
    teaorValue: '10'
  },
  {
    labelText: `101 '08 Húsfeldolgozás, -tartósítás, húskészítmény gyártása`,
    teaorValue: '101'
  },
  {
    labelText: `1011 '08 Húsfeldolgozás, -tartósítás`,
    teaorValue: '1011'
  },
  {
    labelText: `1012 '08 Baromfihús feldolgozása, tartósítása`,
    teaorValue: '1012'
  },
  {
    labelText: `1013 '08 Hús-, baromfihús-készítmény gyártása`,
    teaorValue: '1013'
  },
  {
    labelText: `102 '08 Halfeldolgozás, -tartósítás`,
    teaorValue: '102'
  },
  {
    labelText: `1020 '08 Halfeldolgozás, -tartósítás`,
    teaorValue: '1020'
  },
  {
    labelText: `103 '08 Gyümölcs-, zöldségfeldolgozás, -tartósítás`,
    teaorValue: '103'
  },
  {
    labelText: `1031 '08 Burgonyafeldolgozás, -tartósítás`,
    teaorValue: '1031'
  },
  {
    labelText: `1032 '08 Gyümölcs-, zöldséglé gyártása`,
    teaorValue: '1032'
  },
  {
    labelText: `1039 '08 Egyéb gyümölcs-, zöldségfeldolgozás, -tartósítás`,
    teaorValue: '1039'
  },
  {
    labelText: `104 '08 Növényi, állati olaj gyártása`,
    teaorValue: '104'
  },
  {
    labelText: `1041 '08 Olaj gyártása`,
    teaorValue: '1041'
  },
  {
    labelText: `1042 '08 Margarin gyártása`,
    teaorValue: '1042'
  },
  {
    labelText: `105 '08 Tejfeldolgozás`,
    teaorValue: '105'
  },
  {
    labelText: `1051 '08 Tejtermék gyártása`,
    teaorValue: '1051'
  },
  {
    labelText: `1052 '08 Jégkrém gyártása`,
    teaorValue: '1052'
  },
  {
    labelText: `106 '08 Malomipari termék, keményítő gyártása`,
    teaorValue: '106'
  },
  {
    labelText: `1061 '08 Malomipari termék gyártása`,
    teaorValue: '1061'
  },
  {
    labelText: `1062 '08 Keményítő, keményítőtermék gyártása`,
    teaorValue: '1062'
  },
  {
    labelText: `107 '08 Pékáru, tésztafélék gyártása`,
    teaorValue: '107'
  },
  {
    labelText: `1071 '08 Kenyér; friss pékáru gyártása`,
    teaorValue: '1071'
  },
  {
    labelText: `1072 '08 Tartósított lisztes áru gyártása`,
    teaorValue: '1072'
  },
  {
    labelText: `1073 '08 Tésztafélék gyártása`,
    teaorValue: '1073'
  },
  {
    labelText: `108 '08 Egyéb élelmiszer gyártása`,
    teaorValue: '108'
  },
  {
    labelText: `1081 '08 Cukorgyártás`,
    teaorValue: '1081'
  },
  {
    labelText: `1082 '08 Édesség gyártása`,
    teaorValue: '1082'
  },
  {
    labelText: `1083 '08 Tea, kávé feldolgozása`,
    teaorValue: '1083'
  },
  {
    labelText: `1084 '08 Fűszer, ételízesítő gyártása`,
    teaorValue: '1084'
  },
  {
    labelText: `1085 '08 Készétel gyártása`,
    teaorValue: '1085'
  },
  {
    labelText: `1086 '08 Homogenizált, diétás étel gyártása`,
    teaorValue: '1086'
  },
  {
    labelText: `1089 '08 M`,
    teaorValue: '1089'
  },
  {
    labelText: `109 '08 Takarmány gyártása`,
    teaorValue: '109'
  },
  {
    labelText: `1091 '08 Haszonállat-eledel gyártása`,
    teaorValue: '1091'
  },
  {
    labelText: `1092 '08 Hobbiállat-eledel gyártása`,
    teaorValue: '1092'
  },
  {
    labelText: `11 '08 Italgyártás`,
    teaorValue: '11'
  },
  {
    labelText: `110 '08 Italgyártás`,
    teaorValue: '110'
  },
  {
    labelText: `1101 '08 Desztillált szeszes ital gyártása`,
    teaorValue: '1101'
  },
  {
    labelText: `1102 '08 Szőlőbor termelése`,
    teaorValue: '1102'
  },
  {
    labelText: `1103 '08 Gyümölcsbor termelése`,
    teaorValue: '1103'
  },
  {
    labelText: `1104 '08 Egyéb nem desztillált, erjesztett ital gyártása`,
    teaorValue: '1104'
  },
  {
    labelText: `1105 '08 Sörgyártás`,
    teaorValue: '1105'
  },
  {
    labelText: `1106 '08 Malátagyártás`,
    teaorValue: '1106'
  },
  {
    labelText: `1107 '08 Üdítőital, ásványvíz gyártása`,
    teaorValue: '1107'
  },
  {
    labelText: `12 '08 Dohánytermék gyártása`,
    teaorValue: '12'
  },
  {
    labelText: `120 '08 Dohánytermék gyártása`,
    teaorValue: '120'
  },
  {
    labelText: `1200 '08 Dohánytermék gyártása`,
    teaorValue: '1200'
  },
  {
    labelText: `13 '08 Textília gyártása`,
    teaorValue: '13'
  },
  {
    labelText: `131 '08 Textilszálak fonása`,
    teaorValue: '131'
  },
  {
    labelText: `1310 '08 Textilszálak fonása`,
    teaorValue: '1310'
  },
  {
    labelText: `132 '08 Textilszövés`,
    teaorValue: '132'
  },
  {
    labelText: `1320 '08 Textilszövés`,
    teaorValue: '1320'
  },
  {
    labelText: `133 '08 Textilkikészítés`,
    teaorValue: '133'
  },
  {
    labelText: `1330 '08 Textilkikészítés`,
    teaorValue: '1330'
  },
  {
    labelText: `139 '08 Egyéb textiláru gyártása`,
    teaorValue: '139'
  },
  {
    labelText: `1391 '08 Kötött, hurkolt kelme gyártása`,
    teaorValue: '1391'
  },
  {
    labelText: `1392 '08 Konfekcionált textiláru gyártása (kivéve: ruházat)`,
    teaorValue: '1392'
  },
  {
    labelText: `1393 '08 Szőnyeggyártás`,
    teaorValue: '1393'
  },
  {
    labelText: `1394 '08 Kötéláru gyártása`,
    teaorValue: '1394'
  },
  {
    labelText: `1395 '08 Nem szőtt textília és termék gyártása (kivéve: ruházat)`,
    teaorValue: '1395'
  },
  {
    labelText: `1396 '08 Műszaki textiláru gyártása`,
    teaorValue: '1396'
  },
  {
    labelText: `1399 '08 Egyéb textiláru gyártása m`,
    teaorValue: '1399'
  },
  {
    labelText: `14 '08 Ruházati termék gyártása`,
    teaorValue: '14'
  },
  {
    labelText: `141 '08 Ruházat gyártása (kivéve: szőrmeruházat)`,
    teaorValue: '141'
  },
  {
    labelText: `1411 '08 Bőrruházat gyártása`,
    teaorValue: '1411'
  },
  {
    labelText: `1412 '08 Munkaruházat gyártása`,
    teaorValue: '1412'
  },
  {
    labelText: `1413 '08 Felsőruházat gyártása (kivéve: munkaruházat)`,
    teaorValue: '1413'
  },
  {
    labelText: `1414 '08 Alsóruházat gyártása`,
    teaorValue: '1414'
  },
  {
    labelText: `1419 '08 Egyéb ruházat, kiegészítők gyártása`,
    teaorValue: '1419'
  },
  {
    labelText: `142 '08 Szőrmecikk gyártása`,
    teaorValue: '142'
  },
  {
    labelText: `1420 '08 Szőrmecikk gyártása`,
    teaorValue: '1420'
  },
  {
    labelText: `143 '08 Kötött, hurkolt cikk gyártása`,
    teaorValue: '143'
  },
  {
    labelText: `1431 '08 Kötött, hurkolt harisnyafélék gyártása`,
    teaorValue: '1431'
  },
  {
    labelText: `1439 '08 Egyéb kötött, hurkolt ruházati termék gyártása`,
    teaorValue: '1439'
  },
  {
    labelText: `15 '08 Bőr, bőrtermék, lábbeli gyártása`,
    teaorValue: '15'
  },
  {
    labelText: `151 '08 Bőr, szőrme kikészítése; táskafélék, szíjazat gyártása`,
    teaorValue: '151'
  },
  {
    labelText: `1511 '08 Bőr, szőrme kikészítése`,
    teaorValue: '1511'
  },
  {
    labelText: `1512 '08 Táskafélék, szíjazat gyártása`,
    teaorValue: '1512'
  },
  {
    labelText: `152 '08 Lábbeligyártás`,
    teaorValue: '152'
  },
  {
    labelText: `1520 '08 Lábbeligyártás`,
    teaorValue: '1520'
  },
  {
    labelText: `16 '08 Fafeldolgozás (kivéve: bútor), fonottáru gyártása`,
    teaorValue: '16'
  },
  {
    labelText: `161 '08 Fűrészárugyártás`,
    teaorValue: '161'
  },
  {
    labelText: `1610 '08 Fűrészárugyártás`,
    teaorValue: '1610'
  },
  {
    labelText: `162 '08 Fa-, parafatermék, fonottáru gyártása`,
    teaorValue: '162'
  },
  {
    labelText: `1621 '08 Falemezgyártás`,
    teaorValue: '1621'
  },
  {
    labelText: `1622 '08 Parkettagyártás`,
    teaorValue: '1622'
  },
  {
    labelText: `1623 '08 Épületasztalos-ipari termék gyártása`,
    teaorValue: '1623'
  },
  {
    labelText: `1624 '08 Tároló fatermék gyártása`,
    teaorValue: '1624'
  },
  {
    labelText: `1629 '08 Egyéb fa-, parafatermék, fonottáru gyártása`,
    teaorValue: '1629'
  },
  {
    labelText: `17 '08 Papír, papírtermék gyártása`,
    teaorValue: '17'
  },
  {
    labelText: `171 '08 Papíripari rostanyag, papír gyártása`,
    teaorValue: '171'
  },
  {
    labelText: `1711 '08 Papíripari rostanyag gyártása`,
    teaorValue: '1711'
  },
  {
    labelText: `1712 '08 Papírgyártás`,
    teaorValue: '1712'
  },
  {
    labelText: `172 '08 Papírtermék gyártása`,
    teaorValue: '172'
  },
  {
    labelText: `1721 '08 Papír csomagolóeszköz gyártása`,
    teaorValue: '1721'
  },
  {
    labelText: `1722 '08 Háztartási, egészségügyi papírtermék gyártása`,
    teaorValue: '1722'
  },
  {
    labelText: `1723 '08 Irodai papíráru gyártása`,
    teaorValue: '1723'
  },
  {
    labelText: `1724 '08 Tapétagyártás`,
    teaorValue: '1724'
  },
  {
    labelText: `1729 '08 Egyéb papír-, kartontermék gyártása`,
    teaorValue: '1729'
  },
  {
    labelText: `18 '08 Nyomdai és egyéb sokszorosítási tevékenység`,
    teaorValue: '18'
  },
  {
    labelText: `181 '08 Nyomdai tevékenység`,
    teaorValue: '181'
  },
  {
    labelText: `1811 '08 Napilapnyomás`,
    teaorValue: '1811'
  },
  {
    labelText: `1812 '08 Nyomás (kivéve: napilap)`,
    teaorValue: '1812'
  },
  {
    labelText: `1813 '08 Nyomdai előkészítő tevékenység`,
    teaorValue: '1813'
  },
  {
    labelText: `1814 '08 Könyvkötés, kapcsolódó szolgáltatás`,
    teaorValue: '1814'
  },
  {
    labelText: `182 '08 Egyéb sokszorosítás`,
    teaorValue: '182'
  },
  {
    labelText: `1820 '08 Egyéb sokszorosítás`,
    teaorValue: '1820'
  },
  {
    labelText: `19 '08 Kokszgyártás, kőolaj-feldolgozás`,
    teaorValue: '19'
  },
  {
    labelText: `191 '08 Kokszgyártás`,
    teaorValue: '191'
  },
  {
    labelText: `1910 '08 Kokszgyártás`,
    teaorValue: '1910'
  },
  {
    labelText: `192 '08 Kőolaj-feldolgozás`,
    teaorValue: '192'
  },
  {
    labelText: `1920 '08 Kőolaj-feldolgozás`,
    teaorValue: '1920'
  },
  {
    labelText: `20 '08 Vegyi anyag, termék gyártása`,
    teaorValue: '20'
  },
  {
    labelText: `201 '08 Vegyi alapanyag gyártása`,
    teaorValue: '201'
  },
  {
    labelText: `2011 '08 Ipari gáz gyártása`,
    teaorValue: '2011'
  },
  {
    labelText: `2012 '08 Színezék, pigment gyártása`,
    teaorValue: '2012'
  },
  {
    labelText: `2013 '08 Szervetlen vegyi alapanyag gyártása`,
    teaorValue: '2013'
  },
  {
    labelText: `2014 '08 Szerves vegyi alapanyag gyártása`,
    teaorValue: '2014'
  },
  {
    labelText: `2015 '08 Műtrágya, nitrogénvegyület gyártása`,
    teaorValue: '2015'
  },
  {
    labelText: `2016 '08 Műanyag-alapanyag gyártása`,
    teaorValue: '2016'
  },
  {
    labelText: `2017 '08 Szintetikus kaucsuk alapanyag gyártása`,
    teaorValue: '2017'
  },
  {
    labelText: `202 '08 Mezőgazdasági vegyi termék gyártása`,
    teaorValue: '202'
  },
  {
    labelText: `2020 '08 Mezőgazdasági vegyi termék gyártása`,
    teaorValue: '2020'
  },
  {
    labelText: `203 '08 Festék, bevonóanyag gyártása`,
    teaorValue: '203'
  },
  {
    labelText: `2030 '08 Festék, bevonóanyag gyártása`,
    teaorValue: '2030'
  },
  {
    labelText: `204 '08 Tisztítószer, testápolási cikk gyártása`,
    teaorValue: '204'
  },
  {
    labelText: `2041 '08 Tisztítószer gyártása`,
    teaorValue: '2041'
  },
  {
    labelText: `2042 '08 Testápolási cikk gyártása`,
    teaorValue: '2042'
  },
  {
    labelText: `205 '08 Egyéb vegyi termék gyártása`,
    teaorValue: '205'
  },
  {
    labelText: `2051 '08 Robbanóanyag gyártása`,
    teaorValue: '2051'
  },
  {
    labelText: `2052 '08 Ragasztószergyártás`,
    teaorValue: '2052'
  },
  {
    labelText: `2053 '08 Illóolajgyártás`,
    teaorValue: '2053'
  },
  {
    labelText: `2059 '08 M`,
    teaorValue: '2059'
  },
  {
    labelText: `206 '08 Vegyi szál gyártása`,
    teaorValue: '206'
  },
  {
    labelText: `2060 '08 Vegyi szál gyártása`,
    teaorValue: '2060'
  },
  {
    labelText: `21 '08 Gyógyszergyártás`,
    teaorValue: '21'
  },
  {
    labelText: `211 '08 Gyógyszeralapanyag-gyártás`,
    teaorValue: '211'
  },
  {
    labelText: `2110 '08 Gyógyszeralapanyag-gyártás`,
    teaorValue: '2110'
  },
  {
    labelText: `212 '08 Gyógyszerkészítmény gyártása`,
    teaorValue: '212'
  },
  {
    labelText: `2120 '08 Gyógyszerkészítmény gyártása`,
    teaorValue: '2120'
  },
  {
    labelText: `22 '08 Gumi-, műanyag termék gyártása`,
    teaorValue: '22'
  },
  {
    labelText: `221 '08 Gumitermék gyártása`,
    teaorValue: '221'
  },
  {
    labelText: `2211 '08 Gumiabroncs, gumitömlő gyártása`,
    teaorValue: '2211'
  },
  {
    labelText: `2219 '08 Egyéb gumitermék gyártása`,
    teaorValue: '2219'
  },
  {
    labelText: `222 '08 Műanyag termék gyártása`,
    teaorValue: '222'
  },
  {
    labelText: `2221 '08 Műanyag lap, lemez, fólia, cső, profil gyártása`,
    teaorValue: '2221'
  },
  {
    labelText: `2222 '08 Műanyag csomagolóeszköz gyártása`,
    teaorValue: '2222'
  },
  {
    labelText: `2223 '08 Műanyag építőanyag gyártása`,
    teaorValue: '2223'
  },
  {
    labelText: `2229 '08 Egyéb műanyag termék gyártása`,
    teaorValue: '2229'
  },
  {
    labelText: `23 '08 Nemfém ásványi termék gyártása`,
    teaorValue: '23'
  },
  {
    labelText: `231 '08 Üveg, üvegtermék gyártása`,
    teaorValue: '231'
  },
  {
    labelText: `2311 '08 Síküveggyártás`,
    teaorValue: '2311'
  },
  {
    labelText: `2312 '08 Síküveg továbbfeldolgozása`,
    teaorValue: '2312'
  },
  {
    labelText: `2313 '08 Öblösüveggyártás`,
    teaorValue: '2313'
  },
  {
    labelText: `2314 '08 Üvegszálgyártás`,
    teaorValue: '2314'
  },
  {
    labelText: `2319 '08 Műszaki, egyéb üvegtermék gyártása`,
    teaorValue: '2319'
  },
  {
    labelText: `232 '08 Tűzálló termék gyártása`,
    teaorValue: '232'
  },
  {
    labelText: `2320 '08 Tűzálló termék gyártása`,
    teaorValue: '2320'
  },
  {
    labelText: `233 '08 Kerámia, agyag építőanyag gyártása`,
    teaorValue: '233'
  },
  {
    labelText: `2331 '08 Kerámiacsempe, -lap gyártása`,
    teaorValue: '2331'
  },
  {
    labelText: `2332 '08 Égetett agyag építőanyag gyártása`,
    teaorValue: '2332'
  },
  {
    labelText: `234 '08 Porcelán, kerámiatermék gyártása`,
    teaorValue: '234'
  },
  {
    labelText: `2341 '08 Háztartási kerámia gyártása`,
    teaorValue: '2341'
  },
  {
    labelText: `2342 '08 Egészségügyi kerámia gyártása`,
    teaorValue: '2342'
  },
  {
    labelText: `2343 '08 Kerámia szigetelő gyártása`,
    teaorValue: '2343'
  },
  {
    labelText: `2344 '08 Műszaki kerámia gyártása`,
    teaorValue: '2344'
  },
  {
    labelText: `2349 '08 Egyéb kerámiatermék gyártása`,
    teaorValue: '2349'
  },
  {
    labelText: `235 '08 Cement-, mész-, gipszgyártás`,
    teaorValue: '235'
  },
  {
    labelText: `2351 '08 Cementgyártás`,
    teaorValue: '2351'
  },
  {
    labelText: `2352 '08 Mész-, gipszgyártás`,
    teaorValue: '2352'
  },
  {
    labelText: `236 '08 Beton-, gipsz-, cementtermék gyártása`,
    teaorValue: '236'
  },
  {
    labelText: `2361 '08 Építé si betontermék gyártása`,
    teaorValue: '2361'
  },
  {
    labelText: `2362 '08 Építési gipsztermék gyártása`,
    teaorValue: '2362'
  },
  {
    labelText: `2363 '08 Előre kevert beton gyártása`,
    teaorValue: '2363'
  },
  {
    labelText: `2364 '08 Habarcsgyártás`,
    teaorValue: '2364'
  },
  {
    labelText: `2365 '08 Szálerősítésű cement gyártása`,
    teaorValue: '2365'
  },
  {
    labelText: `2369 '08 Egyéb beton-, gipsz-, cementtermék gyártása`,
    teaorValue: '2369'
  },
  {
    labelText: `237 '08 Kőmegmunkálás`,
    teaorValue: '237'
  },
  {
    labelText: `2370 '08 Kőmegmunkálás`,
    teaorValue: '2370'
  },
  {
    labelText: `239 '08 Egyéb csiszolótermék és nemfém ásványi termék gyártása m`,
    teaorValue: '239'
  },
  {
    labelText: `2391 '08 Csiszolótermék gyártása`,
    teaorValue: '2391'
  },
  {
    labelText: `2399 '08 M`,
    teaorValue: '2399'
  },
  {
    labelText: `24 '08 Fémalapanyag gyártása`,
    teaorValue: '24'
  },
  {
    labelText: `241 '08 Vas-, acél-, vasötvözet-alapanyag gyártása`,
    teaorValue: '241'
  },
  {
    labelText: `2410 '08 Vas-, acél-, vasötvözet-alapanyag gyártása`,
    teaorValue: '2410'
  },
  {
    labelText: `242 '08 Acélcsőgyártás`,
    teaorValue: '242'
  },
  {
    labelText: `2420 '08 Acélcsőgyártás`,
    teaorValue: '2420'
  },
  {
    labelText: `243 '08 Egyéb kohászati termék gyártása acélból`,
    teaorValue: '243'
  },
  {
    labelText: `2431 '08 Hidegen húzott acélrúd gyártása`,
    teaorValue: '2431'
  },
  {
    labelText: `2432 '08 Hidegen hengerelt keskeny acélszalag gyártása`,
    teaorValue: '2432'
  },
  {
    labelText: `2433 '08 Hidegen hajlított acélidom gyártása`,
    teaorValue: '2433'
  },
  {
    labelText: `2434 '08 Hidegen húzott acélhuzal gyártása`,
    teaorValue: '2434'
  },
  {
    labelText: `244 '08 Nem vas fém alapanyag gyártása`,
    teaorValue: '244'
  },
  {
    labelText: `2441 '08 Nemesfémgyártás`,
    teaorValue: '2441'
  },
  {
    labelText: `2442 '08 Alumíniumgyártás`,
    teaorValue: '2442'
  },
  {
    labelText: `2443 '08 Ólom, cink, ón gyártása`,
    teaorValue: '2443'
  },
  {
    labelText: `2444 '08 Rézgyártás`,
    teaorValue: '2444'
  },
  {
    labelText: `2445 '08 Egyéb nem vas fém gyártása`,
    teaorValue: '2445'
  },
  {
    labelText: `2446 '08 Nukleáris fűtőanyag gyártása`,
    teaorValue: '2446'
  },
  {
    labelText: `245 '08 Fémöntés`,
    teaorValue: '245'
  },
  {
    labelText: `2451 '08 Vasöntés`,
    teaorValue: '2451'
  },
  {
    labelText: `2452 '08 Acélöntés`,
    teaorValue: '2452'
  },
  {
    labelText: `2453 '08 Könnyűfémöntés`,
    teaorValue: '2453'
  },
  {
    labelText: `2454 '08 Egyéb nem vas fém öntése`,
    teaorValue: '2454'
  },
  {
    labelText: `25 '08 Fémfeldolgozási termék gyártása`,
    teaorValue: '25'
  },
  {
    labelText: `251 '08 Fémszerkezet, -épületelem gyártása`,
    teaorValue: '251'
  },
  {
    labelText: `2511 '08 Fémszerkezet gyártása`,
    teaorValue: '2511'
  },
  {
    labelText: `2512 '08 Fém épületelem gyártása`,
    teaorValue: '2512'
  },
  {
    labelText: `252 '08 Fűtési kazán, radiátor, fémtartály gyártása`,
    teaorValue: '252'
  },
  {
    labelText: `2521 '08 Központi fűtési kazán, radiátor gyártása`,
    teaorValue: '2521'
  },
  {
    labelText: `2529 '08 Fémtartály gyártása`,
    teaorValue: '2529'
  },
  {
    labelText: `253 '08 Gőzkazán gyártása`,
    teaorValue: '253'
  },
  {
    labelText: `2530 '08 Gőzkazán gyártása`,
    teaorValue: '2530'
  },
  {
    labelText: `254 '08 Fegyver-, lőszergyártás`,
    teaorValue: '254'
  },
  {
    labelText: `2540 '08 Fegyver-, lőszergyártás`,
    teaorValue: '2540'
  },
  {
    labelText: `255 '08 Fémalakítás, porkohászat`,
    teaorValue: '255'
  },
  {
    labelText: `2550 '08 Fémalakítás, porkohászat`,
    teaorValue: '2550'
  },
  {
    labelText: `256 '08 Fém felületkezelése, megmunkálása`,
    teaorValue: '256'
  },
  {
    labelText: `2561 '08 Fémfelület-kezelés`,
    teaorValue: '2561'
  },
  {
    labelText: `2562 '08 Fémmegmunkálás`,
    teaorValue: '2562'
  },
  {
    labelText: `257 '08 Evőeszköz, szerszám, általános fémáru gyártása`,
    teaorValue: '257'
  },
  {
    labelText: `2571 '08 Evőeszköz gyártása`,
    teaorValue: '2571'
  },
  {
    labelText: `2572 '08 Lakat-, zárgyártás`,
    teaorValue: '2572'
  },
  {
    labelText: `2573 '08 Szerszámgyártás`,
    teaorValue: '2573'
  },
  {
    labelText: `259 '08 Egyéb fémfeldolgozási termék gyártása`,
    teaorValue: '259'
  },
  {
    labelText: `2591 '08 Acél tárolóeszköz gyártása`,
    teaorValue: '2591'
  },
  {
    labelText: `2592 '08 Könnyűfém csomagolóeszköz gyártása`,
    teaorValue: '2592'
  },
  {
    labelText: `2593 '08 Huzaltermék gyártása`,
    teaorValue: '2593'
  },
  {
    labelText: `2594 '08 Kötőelem, csavar gyártása`,
    teaorValue: '2594'
  },
  {
    labelText: `2599 '08 M`,
    teaorValue: '2599'
  },
  {
    labelText: `26 '08 Számítógép, elektronikai, optikai termék gyártása`,
    teaorValue: '26'
  },
  {
    labelText: `261 '08 Elektronikai alkatrész, áramköri kártya gyártása`,
    teaorValue: '261'
  },
  {
    labelText: `2611 '08 Elektronikai alkatrész gyártása`,
    teaorValue: '2611'
  },
  {
    labelText: `2612 '08 Elektronikai áramköri kártya gyártása`,
    teaorValue: '2612'
  },
  {
    labelText: `262 '08 Számítógép, perifériás egység gyártása`,
    teaorValue: '262'
  },
  {
    labelText: `2620 '08 Számítógép, perifériás egység gyártása`,
    teaorValue: '2620'
  },
  {
    labelText: `263 '08 Híradás-technikai berendezés gyártása`,
    teaorValue: '263'
  },
  {
    labelText: `2630 '08 Híradás-technikai berendezés gyártása`,
    teaorValue: '2630'
  },
  {
    labelText: `264 '08 Elektronikus fogyasztási cikk gyártása`,
    teaorValue: '264'
  },
  {
    labelText: `2640 '08 Elektronikus fogyasztási cikk gyártása`,
    teaorValue: '2640'
  },
  {
    labelText: `265 '08 Műszer-, óragyártás`,
    teaorValue: '265'
  },
  {
    labelText: `2651 '08 Mérőműszergyártás`,
    teaorValue: '2651'
  },
  {
    labelText: `2652 '08 Óragyártás`,
    teaorValue: '2652'
  },
  {
    labelText: `266 '08 Elektronikus orvosi berendezés gyártása`,
    teaorValue: '266'
  },
  {
    labelText: `2660 '08 Elektronikus orvosi berendezés gyártása`,
    teaorValue: '2660'
  },
  {
    labelText: `267 '08 Optikai eszköz gyártása`,
    teaorValue: '267'
  },
  {
    labelText: `2670 '08 Optikai eszköz gyártása`,
    teaorValue: '2670'
  },
  {
    labelText: `268 '08 Mágneses, optikai információhordozó gyártása`,
    teaorValue: '268'
  },
  {
    labelText: `2680 '08 Mágneses, optikai információhordozó gyártása`,
    teaorValue: '2680'
  },
  {
    labelText: `27 '08 Villamos berendezés gyártása`,
    teaorValue: '27'
  },
  {
    labelText: `271 '08 Villamos motor, áramfejlesztő, áramelosztó, -szabályozó készülék gyártása`,
    teaorValue: '271'
  },
  {
    labelText: `2711 '08 Villamos motor, áramfejlesztő gyártása`,
    teaorValue: '2711'
  },
  {
    labelText: `2712 '08 Áramelosztó, -szabályozó készülék gyártása`,
    teaorValue: '2712'
  },
  {
    labelText: `272 '08 Akkumulátor, szárazelem gyártása`,
    teaorValue: '272'
  },
  {
    labelText: `2720 '08 Akkumulátor, szárazelem gyártása`,
    teaorValue: '2720'
  },
  {
    labelText: `273 '08 Vezeték, kábel, szerelvény gyártása`,
    teaorValue: '273'
  },
  {
    labelText: `2731 '08 Száloptikai kábel gyártása`,
    teaorValue: '2731'
  },
  {
    labelText: `2732 '08 Egyéb elektronikus, villamos vezeték, kábel gyártása`,
    teaorValue: '2732'
  },
  {
    labelText: `2733 '08 Szerelvény gyártása`,
    teaorValue: '2733'
  },
  {
    labelText: `274 '08 Villamos világítóeszköz gyártása`,
    teaorValue: '274'
  },
  {
    labelText: `2740 '08 Villamos világítóeszköz gyártása`,
    teaorValue: '2740'
  },
  {
    labelText: `275 '08 Háztartási készülék gyártása`,
    teaorValue: '275'
  },
  {
    labelText: `2751 '08 Háztartási villamos készülék gyártása`,
    teaorValue: '2751'
  },
  {
    labelText: `2752 '08 Nem villamos háztartási készülék gyártása`,
    teaorValue: '2752'
  },
  {
    labelText: `279 '08 Egyéb villamos berendezés gyártása`,
    teaorValue: '279'
  },
  {
    labelText: `2790 '08 Egyéb villamos berendezés gyártása`,
    teaorValue: '2790'
  },
  {
    labelText: `28 '08 Gép, gépi berendezés gyártása`,
    teaorValue: '28'
  },
  {
    labelText: `281 '08 Általános rendeltetésű gép gyártása`,
    teaorValue: '281'
  },
  {
    labelText: `2811 '08 Motor, turbina gyártása (kivéve: légi, közútijármű-motor)`,
    teaorValue: '2811'
  },
  {
    labelText: `2812 '08 Hidraulikus, pneumatikus berendezés gyártása`,
    teaorValue: '2812'
  },
  {
    labelText: `2813 '08 Egyéb szivattyú, kompresszor gyártása`,
    teaorValue: '2813'
  },
  {
    labelText: `2814 '08 Csap, szelep gyártása`,
    teaorValue: '2814'
  },
  {
    labelText: `2815 '08 Csapágy, erőátviteli elem gyártása`,
    teaorValue: '2815'
  },
  {
    labelText: `282 '08 Egyéb általános rendeltetésű gép gyártása`,
    teaorValue: '282'
  },
  {
    labelText: `2821 '08 Fűtőberendezés, kemence gyártása`,
    teaorValue: '2821'
  },
  {
    labelText: `2822 '08 Emelő-, anyagmozgató gép gyártása`,
    teaorValue: '2822'
  },
  {
    labelText: `2823 '08 Irodagép gyártása (kivéve: számítógép és perifériái)`,
    teaorValue: '2823'
  },
  {
    labelText: `2824 '08 Gépi meghajtású hordozható kézi szerszámgép gyártása`,
    teaorValue: '2824'
  },
  {
    labelText: `2825 '08 Nem háztartási hűtő, légállapot-szabályozó gyártása`,
    teaorValue: '2825'
  },
  {
    labelText: `2829 '08 M`,
    teaorValue: '2829'
  },
  {
    labelText: `283 '08 Mezőgazdasági, erdészeti gép gyártása`,
    teaorValue: '283'
  },
  {
    labelText: `2830 '08 Mezőgazdasági, erdészeti gép gyártása`,
    teaorValue: '2830'
  },
  {
    labelText: `284 '08 Szerszámgépgyártás`,
    teaorValue: '284'
  },
  {
    labelText: `2841 '08 Fémmegmunkáló szerszámgép gyártása`,
    teaorValue: '2841'
  },
  {
    labelText: `2849 '08 Egyéb szerszámgép gyártása`,
    teaorValue: '2849'
  },
  {
    labelText: `289 '08 Egyéb speciális rendeltetésű gép gyártása`,
    teaorValue: '289'
  },
  {
    labelText: `2891 '08 Kohászati gép gyártása`,
    teaorValue: '2891'
  },
  {
    labelText: `2892 '08 Bányászati, építőipari gép gyártása`,
    teaorValue: '2892'
  },
  {
    labelText: `2893 '08 Élelmiszer-, dohányipari gép gyártása`,
    teaorValue: '2893'
  },
  {
    labelText: `2894 '08 Textil-, ruházati, bőripari gép gyártása`,
    teaorValue: '2894'
  },
  {
    labelText: `2895 '08 Papíripari gép gyártása`,
    teaorValue: '2895'
  },
  {
    labelText: `2896 '08 Műanyag-, gumifeldolgozó gép gyártása`,
    teaorValue: '2896'
  },
  {
    labelText: `2899 '08 M`,
    teaorValue: '2899'
  },
  {
    labelText: `29 '08 Közúti jármű gyártása`,
    teaorValue: '29'
  },
  {
    labelText: `291 '08 Közúti gépjármű gyártása`,
    teaorValue: '291'
  },
  {
    labelText: `2910 '08 Közúti gépjármű gyártása`,
    teaorValue: '2910'
  },
  {
    labelText: `292 '08 Gépjármű-karosszéria, pótkocsi gyártása`,
    teaorValue: '292'
  },
  {
    labelText: `2920 '08 Gépjármű-karosszéria, pótkocsi gyártása`,
    teaorValue: '2920'
  },
  {
    labelText: `293 '08 Közúti jármű alkatrészeinek gyártása`,
    teaorValue: '293'
  },
  {
    labelText: `2931 '08 Járművillamossági, -elektronikai készülékek gyártása`,
    teaorValue: '2931'
  },
  {
    labelText: `2932 '08 Közúti jármű, járműmotor alkatrészeinek gyártása`,
    teaorValue: '2932'
  },
  {
    labelText: `30 '08 Egyéb jármű gyártása`,
    teaorValue: '30'
  },
  {
    labelText: `301 '08 Hajó, csónak gyártása`,
    teaorValue: '301'
  },
  {
    labelText: `3011 '08 Hajógyártás`,
    teaorValue: '3011'
  },
  {
    labelText: `3012 '08 Szabadidő-, sporthajó gyártása`,
    teaorValue: '3012'
  },
  {
    labelText: `302 '08 Vasúti, kötöttpályás jármű gyártása`,
    teaorValue: '302'
  },
  {
    labelText: `3020 '08 Vasúti, kötöttpályás jármű gyártása`,
    teaorValue: '3020'
  },
  {
    labelText: `303 '08 Légi, űrjármű gyártása`,
    teaorValue: '303'
  },
  {
    labelText: `3030 '08 Légi, űrjármű gyártása`,
    teaorValue: '3030'
  },
  {
    labelText: `304 '08 Katonai harcjármű gyártása`,
    teaorValue: '304'
  },
  {
    labelText: `3040 '08 Katonai harcjármű gyártása`,
    teaorValue: '3040'
  },
  {
    labelText: `309 '08 Egyéb jármű gyártása`,
    teaorValue: '309'
  },
  {
    labelText: `3091 '08 Motorkerékpár gyártása`,
    teaorValue: '3091'
  },
  {
    labelText: `3092 '08 Kerékpár, mozgássérültkocsi gyártása`,
    teaorValue: '3092'
  },
  {
    labelText: `3099 '08 M`,
    teaorValue: '3099'
  },
  {
    labelText: `31 '08 Bútorgyártás`,
    teaorValue: '31'
  },
  {
    labelText: `310 '08 Bútorgyártás`,
    teaorValue: '310'
  },
  {
    labelText: `3101 '08 Irodabútor gyártása`,
    teaorValue: '3101'
  },
  {
    labelText: `3102 '08 Konyhabútorgyártás`,
    teaorValue: '3102'
  },
  {
    labelText: `3103 '08 Ágybetét gyártása`,
    teaorValue: '3103'
  },
  {
    labelText: `3109 '08 Egyéb bútor gyártása`,
    teaorValue: '3109'
  },
  {
    labelText: `32 '08 Egyéb feldolgozóipari tevékenység`,
    teaorValue: '32'
  },
  {
    labelText: `321 '08 Ékszergyártás`,
    teaorValue: '321'
  },
  {
    labelText: `3211 '08 Érmegyártás`,
    teaorValue: '3211'
  },
  {
    labelText: `3212 '08 Ékszergyártás`,
    teaorValue: '3212'
  },
  {
    labelText: `3213 '08 Divatékszer gyártása`,
    teaorValue: '3213'
  },
  {
    labelText: `322 '08 Hangszergyártás`,
    teaorValue: '322'
  },
  {
    labelText: `3220 '08 Hangszergyártás`,
    teaorValue: '3220'
  },
  {
    labelText: `323 '08 Sportszergyártás`,
    teaorValue: '323'
  },
  {
    labelText: `3230 '08 Sportszergyártás`,
    teaorValue: '3230'
  },
  {
    labelText: `324 '08 Játékgyártás`,
    teaorValue: '324'
  },
  {
    labelText: `3240 '08 Játékgyártás`,
    teaorValue: '3240'
  },
  {
    labelText: `325 '08 Orvosi eszköz gyártása`,
    teaorValue: '325'
  },
  {
    labelText: `3250 '08 Orvosi eszköz gyártása`,
    teaorValue: '3250'
  },
  {
    labelText: `329 '08 M`,
    teaorValue: '329'
  },
  {
    labelText: `3291 '08 Seprű-, kefegyártás`,
    teaorValue: '3291'
  },
  {
    labelText: `3299 '08 Egyéb m`,
    teaorValue: '3299'
  },
  {
    labelText: `33 '08 Ipari gép, berendezés, eszköz javítása`,
    teaorValue: '33'
  },
  {
    labelText: `331 '08 Ipari gép, berendezés, eszköz javítása`,
    teaorValue: '331'
  },
  {
    labelText: `3311 '08 Fémfeldolgozási termék javítása`,
    teaorValue: '3311'
  },
  {
    labelText: `3312 '08 Ipari gép, berendezés javítása`,
    teaorValue: '3312'
  },
  {
    labelText: `3313 '08 Elektronikus, optikai eszköz javítása`,
    teaorValue: '3313'
  },
  {
    labelText: `3314 '08 Ipari villamos gép, berendezés javítása`,
    teaorValue: '3314'
  },
  {
    labelText: `3315 '08 Hajó, csónak javítása`,
    teaorValue: '3315'
  },
  {
    labelText: `3316 '08 Repülőgép, űrhajó javítása`,
    teaorValue: '3316'
  },
  {
    labelText: `3317 '08 Egyéb közlekedési eszköz javítása`,
    teaorValue: '3317'
  },
  {
    labelText: `3319 '08 Egyéb ipari eszköz javítása`,
    teaorValue: '3319'
  },
  {
    labelText: `332 '08 Ipari gép, berendezés üzembe helyezése`,
    teaorValue: '332'
  },
  {
    labelText: `3320 '08 Ipari gép, berendezés üzembe helyezése`,
    teaorValue: '3320'
  },
  {
    labelText: `35 '08 Villamosenergia-, gáz-, gőzellátás, légkondicionálás`,
    teaorValue: '35'
  },
  {
    labelText: `351 '08 Villamosenergia-termelés, -ellátás`,
    teaorValue: '351'
  },
  {
    labelText: `3511 '08 Villamosenergia-termelés`,
    teaorValue: '3511'
  },
  {
    labelText: `3512 '08 Villamosenergia-szállítás`,
    teaorValue: '3512'
  },
  {
    labelText: `3513 '08 Villamosenergia-elosztás`,
    teaorValue: '3513'
  },
  {
    labelText: `3514 '08 Villamosenergia-kereskedelem`,
    teaorValue: '3514'
  },
  {
    labelText: `352 '08 Gázellátás`,
    teaorValue: '352'
  },
  {
    labelText: `3521 '08 Gázgyártás`,
    teaorValue: '3521'
  },
  {
    labelText: `3522 '08 Gázelosztás`,
    teaorValue: '3522'
  },
  {
    labelText: `3523 '08 Gázkereskedelem`,
    teaorValue: '3523'
  },
  {
    labelText: `353 '08 Gőzellátás, légkondicionálás`,
    teaorValue: '353'
  },
  {
    labelText: `3530 '08 Gőzellátás, légkondicionálás`,
    teaorValue: '3530'
  },
  {
    labelText: `36 '08 Víztermelés, -kezelés, -ellátás`,
    teaorValue: '36'
  },
  {
    labelText: `360 '08 Víztermelés, -kezelés, -ellátás`,
    teaorValue: '360'
  },
  {
    labelText: `3600 '08 Víztermelés, -kezelés, -ellátás`,
    teaorValue: '3600'
  },
  {
    labelText: `37 '08 Szennyvíz gyűjtése, kezelése`,
    teaorValue: '37'
  },
  {
    labelText: `370 '08 Szennyvíz gyűjtése, kezelése`,
    teaorValue: '370'
  },
  {
    labelText: `3700 '08 Szennyvíz gyűjtése, kezelése`,
    teaorValue: '3700'
  },
  {
    labelText: `38 '08 Hulladékgazdálkodás`,
    teaorValue: '38'
  },
  {
    labelText: `381 '08 Hulladékgyűjtés`,
    teaorValue: '381'
  },
  {
    labelText: `3811 '08 Nem veszélyes hulladék gyűjtése`,
    teaorValue: '3811'
  },
  {
    labelText: `3812 '08 Veszélyes hulladék gyűjtése`,
    teaorValue: '3812'
  },
  {
    labelText: `382 '08 Hulladékkezelés, -ártalmatlanítás`,
    teaorValue: '382'
  },
  {
    labelText: `3821 '08 Nem veszélyes hulladék kezelése, ártalmatlanítása`,
    teaorValue: '3821'
  },
  {
    labelText: `3822 '08 Veszélyes hulladék kezelése, ártalmatlanítása`,
    teaorValue: '3822'
  },
  {
    labelText: `383 '08 Hulladékanyag hasznosítása`,
    teaorValue: '383'
  },
  {
    labelText: `3831 '08 Használt eszköz bontása`,
    teaorValue: '3831'
  },
  {
    labelText: `3832 '08 Hulladék újrahasznosítása`,
    teaorValue: '3832'
  },
  {
    labelText: `39 '08 Szennyeződésmentesítés, egyéb hulladékkezelés`,
    teaorValue: '39'
  },
  {
    labelText: `390 '08 Szennyeződésmentesítés, egyéb hulladékkezelés`,
    teaorValue: '390'
  },
  {
    labelText: `3900 '08 Szennyeződésmentesítés, egyéb hulladékkezelés`,
    teaorValue: '3900'
  },
  {
    labelText: `41 '08 Épületek építése`,
    teaorValue: '41'
  },
  {
    labelText: `411 '08 Épületépítési projekt szervezése`,
    teaorValue: '411'
  },
  {
    labelText: `4110 '08 Épületépítési projekt szervezése`,
    teaorValue: '4110'
  },
  {
    labelText: `412 '08 Lakó- és nem lakó épület építése`,
    teaorValue: '412'
  },
  {
    labelText: `4120 '08 Lakó- és nem lakó épület építése`,
    teaorValue: '4120'
  },
  {
    labelText: `42 '08 Egyéb építmény építése`,
    teaorValue: '42'
  },
  {
    labelText: `421 '08 Út, vasút építése`,
    teaorValue: '421'
  },
  {
    labelText: `4211 '08 Út, autópálya építése`,
    teaorValue: '4211'
  },
  {
    labelText: `4212 '08 Vasút építése`,
    teaorValue: '4212'
  },
  {
    labelText: `4213 '08 Híd, alagút építése`,
    teaorValue: '4213'
  },
  {
    labelText: `422 '08 Közműépítés`,
    teaorValue: '422'
  },
  {
    labelText: `4221 '08 Folyadék szállítására szolgáló közmű építése`,
    teaorValue: '4221'
  },
  {
    labelText: `4222 '08 Elektromos, híradás-technikai célú közmű építése`,
    teaorValue: '4222'
  },
  {
    labelText: `429 '08 M`,
    teaorValue: '429'
  },
  {
    labelText: `4291 '08 Vízi létesítmény építése`,
    teaorValue: '4291'
  },
  {
    labelText: `4299 '08 Egyéb m`,
    teaorValue: '4299'
  },
  {
    labelText: `43 '08 Speciális szaképítés`,
    teaorValue: '43'
  },
  {
    labelText: `431 '08 Bontás, építési terület előkészítése`,
    teaorValue: '431'
  },
  {
    labelText: `4311 '08 Bontás`,
    teaorValue: '4311'
  },
  {
    labelText: `4312 '08 Építési terület előkészítése`,
    teaorValue: '4312'
  },
  {
    labelText: `4313 '08 Talajmintavétel, próbafúrás`,
    teaorValue: '4313'
  },
  {
    labelText: `432 '08 Épületgépészeti szerelés`,
    teaorValue: '432'
  },
  {
    labelText: `4321 '08 Villanyszerelés`,
    teaorValue: '4321'
  },
  {
    labelText: `4322 '08 Víz-, gáz-, fűtés-, légkondicionáló-szerelés`,
    teaorValue: '4322'
  },
  {
    labelText: `4329 '08 Egyéb épületgépészeti szerelés`,
    teaorValue: '4329'
  },
  {
    labelText: `433 '08 Befejező építés`,
    teaorValue: '433'
  },
  {
    labelText: `4331 '08 Vakolás`,
    teaorValue: '4331'
  },
  {
    labelText: `4332 '08 Épületasztalos-szerkezet szerelése`,
    teaorValue: '4332'
  },
  {
    labelText: `4333 '08 Padló-, falburkolás`,
    teaorValue: '4333'
  },
  {
    labelText: `4334 '08 Festés, üvegezés`,
    teaorValue: '4334'
  },
  {
    labelText: `4339 '08 Egyéb befejező építés m`,
    teaorValue: '4339'
  },
  {
    labelText: `439 '08 Egyéb speciális szaképítés`,
    teaorValue: '439'
  },
  {
    labelText: `4391 '08 Tetőfedés, tetőszerkezet-építés`,
    teaorValue: '4391'
  },
  {
    labelText: `4399 '08 Egyéb speciális szaképítés m`,
    teaorValue: '4399'
  },
  {
    labelText: `45 '08 Gépjármű, motorkerékpár kereskedelme, javítása`,
    teaorValue: '45'
  },
  {
    labelText: `451 '08 Gépjármű-kereskedelem`,
    teaorValue: '451'
  },
  {
    labelText: `4511 '08 Személygépjármű-, könnyűgépjármű-kereskedelem`,
    teaorValue: '4511'
  },
  {
    labelText: `4519 '08 Egyéb gépjármű-kereskedelem`,
    teaorValue: '4519'
  },
  {
    labelText: `452 '08 Gépjárműjavítás, -karbantartás`,
    teaorValue: '452'
  },
  {
    labelText: `4520 '08 Gépjárműjavítás, -karbantartás`,
    teaorValue: '4520'
  },
  {
    labelText: `453 '08 Gépjárműalkatrész-kereskedelem`,
    teaorValue: '453'
  },
  {
    labelText: `4531 '08 Gépjárműalkatrész-nagykereskedelem`,
    teaorValue: '4531'
  },
  {
    labelText: `4532 '08 Gépjárműalkatrész-kiskereskedelem`,
    teaorValue: '4532'
  },
  {
    labelText: `454 '08 Motorkerékpár, -alkatrész kereskedelme, javítása`,
    teaorValue: '454'
  },
  {
    labelText: `4540 '08 Motorkerékpár, -alkatrész kereskedelme, javítása`,
    teaorValue: '4540'
  },
  {
    labelText: `46 '08 Nagykereskedelem (kivéve: jármű, motorkerékpár)`,
    teaorValue: '46'
  },
  {
    labelText: `461 '08 Ügynöki nagykereskedelem`,
    teaorValue: '461'
  },
  {
    labelText: `4611 '08 Mezőgazdasági termék ügynöki nagykereskedelme`,
    teaorValue: '4611'
  },
  {
    labelText: `4612 '08 Alapanyag, üzemanyag ügynöki nagykereskedelme`,
    teaorValue: '4612'
  },
  {
    labelText: `4613 '08 Fa-, építési anyag ügynöki nagykereskedelme`,
    teaorValue: '4613'
  },
  {
    labelText: `4614 '08 Gép, hajó, repülőgép ügynöki nagykereskedelme`,
    teaorValue: '4614'
  },
  {
    labelText: `4615 '08 Bútor, háztartási áru, fémáru ügynöki nagykereskedelme`,
    teaorValue: '4615'
  },
  {
    labelText: `4616 '08 Textil, ruházat, lábbeli, bőráru ügynöki nagykereskedelme`,
    teaorValue: '4616'
  },
  {
    labelText: `4617 '08 Élelmiszer, ital, dohányáru ügynöki nagykereskedelme`,
    teaorValue: '4617'
  },
  {
    labelText: `4618 '08 Egyéb termék ügynöki nagykereskedelme`,
    teaorValue: '4618'
  },
  {
    labelText: `4619 '08 Vegyes termékkörű ügynöki nagykereskedelem`,
    teaorValue: '4619'
  },
  {
    labelText: `462 '08 Mezőgazdasági nyersanyag, élőállat nagykereskedelme`,
    teaorValue: '462'
  },
  {
    labelText: `4621 '08 Gabona, dohány, vetőmag, takarmány nagykereskedelme`,
    teaorValue: '4621'
  },
  {
    labelText: `4622 '08 Dísznövény nagykereskedelme`,
    teaorValue: '4622'
  },
  {
    labelText: `4623 '08 Élőállat nagykereskedelme`,
    teaorValue: '4623'
  },
  {
    labelText: `4624 '08 Bőr nagykereskedelme`,
    teaorValue: '4624'
  },
  {
    labelText: `463 '08 Élelmiszer, ital, dohányáru nagykereskedelme`,
    teaorValue: '463'
  },
  {
    labelText: `4631 '08 Zöldség-, gyümölcs-nagykereskedelem`,
    teaorValue: '4631'
  },
  {
    labelText: `4632 '08 Hús-, húskészítmény nagykereskedelme`,
    teaorValue: '4632'
  },
  {
    labelText: `4633 '08 Tejtermék, tojás, zsiradék nagykereskedelme`,
    teaorValue: '4633'
  },
  {
    labelText: `4634 '08 Ital nagykereskedelme`,
    teaorValue: '4634'
  },
  {
    labelText: `4635 '08 Dohányáru nagykereskedelme`,
    teaorValue: '4635'
  },
  {
    labelText: `4636 '08 Cukor, édesség nagykereskedelme`,
    teaorValue: '4636'
  },
  {
    labelText: `4637 '08 Kávé-, tea-, kakaó-, fűszer-nagykereskedelem`,
    teaorValue: '4637'
  },
  {
    labelText: `4638 '08 Egyéb élelmiszer nagykereskedelme`,
    teaorValue: '4638'
  },
  {
    labelText: `4639 '08 Élelmiszer, ital, dohányáru vegyes nagykereskedelme`,
    teaorValue: '4639'
  },
  {
    labelText: `464 '08 Háztartási cikk nagykereskedelme`,
    teaorValue: '464'
  },
  {
    labelText: `4641 '08 Textil-nagykereskedelem`,
    teaorValue: '4641'
  },
  {
    labelText: `4642 '08 Ruházat, lábbeli nagykereskedelme`,
    teaorValue: '4642'
  },
  {
    labelText: `4643 '08 Elektronikus háztartási cikk nagykereskedelme`,
    teaorValue: '4643'
  },
  {
    labelText: `4644 '08 Porcelán-, üvegáru-, tisztítószer-nagykereskedelem`,
    teaorValue: '4644'
  },
  {
    labelText: `4645 '08 Illatszer nagykereskedelme`,
    teaorValue: '4645'
  },
  {
    labelText: `4646 '08 Gyógyszer, gyógyászati termék nagykereskedelme`,
    teaorValue: '4646'
  },
  {
    labelText: `4647 '08 Bútor, szőnyeg, világítóberendezés nagykereskedelme`,
    teaorValue: '4647'
  },
  {
    labelText: `4648 '08 Óra-, ékszer-nagykereskedelem`,
    teaorValue: '4648'
  },
  {
    labelText: `4649 '08 Egyéb háztartási cikk nagykereskedelme m`,
    teaorValue: '4649'
  },
  {
    labelText: `465 '08 Információtechnológiai, híradás-technikai termék nagykereskedelme`,
    teaorValue: '465'
  },
  {
    labelText: `4651 '08 Számítógép, periféria, szoftver nagykereskedelme`,
    teaorValue: '4651'
  },
  {
    labelText: `4652 '08 Elektronikus, híradás-technikai berendezés, és alkatrészei nagykereskedelme`,
    teaorValue: '4652'
  },
  {
    labelText: `466 '08 Egyéb gép, berendezés, tartozék nagykereskedelme`,
    teaorValue: '466'
  },
  {
    labelText: `4661 '08 Mezőgazdasági gép, berendezés nagykereskedelme`,
    teaorValue: '4661'
  },
  {
    labelText: `4662 '08 Szerszámgép-nagykereskedelem`,
    teaorValue: '4662'
  },
  {
    labelText: `4663 '08 Bányászati-, építőipari gép nagykereskedelme`,
    teaorValue: '4663'
  },
  {
    labelText: `4664 '08 Textilipari gép, varró-, kötőgép nagykereskedelme`,
    teaorValue: '4664'
  },
  {
    labelText: `4665 '08 Irodabútor-nagykereskedelem`,
    teaorValue: '4665'
  },
  {
    labelText: `4666 '08 Egyéb irodagép, -berendezés nagykereskedelme`,
    teaorValue: '4666'
  },
  {
    labelText: `4669 '08 Egyéb m`,
    teaorValue: '4669'
  },
  {
    labelText: `467 '08 Egyéb szakosodott nagykereskedelem`,
    teaorValue: '467'
  },
  {
    labelText: `4671 '08 Üzem-, tüzelőanyag nagykereskedelme`,
    teaorValue: '4671'
  },
  {
    labelText: `4672 '08 Fém-, érc-nagykereskedelem`,
    teaorValue: '4672'
  },
  {
    labelText: `4673 '08 Fa-, építőanyag-, szaniteráru-nagykereskedelem`,
    teaorValue: '4673'
  },
  {
    labelText: `4674 '08 Fémáru, szerelvény, fűtési berendezés nagykereskedelme`,
    teaorValue: '4674'
  },
  {
    labelText: `4675 '08 Vegyi áru nagykereskedelme`,
    teaorValue: '4675'
  },
  {
    labelText: `4676 '08 Egyéb termelési célú termék nagykereskedelme`,
    teaorValue: '4676'
  },
  {
    labelText: `4677 '08 Hulladék-nagykereskedelem`,
    teaorValue: '4677'
  },
  {
    labelText: `469 '08 Vegyestermékkörű nagykereskedelem`,
    teaorValue: '469'
  },
  {
    labelText: `4690 '08 Vegyestermékkörű nagykereskedelem`,
    teaorValue: '4690'
  },
  {
    labelText: `47 '08 Kiskereskedelem (kivéve: gépjármű, motorkerékpár)`,
    teaorValue: '47'
  },
  {
    labelText: `471 '08 Nem szakosodott bolti vegyes kiskereskedelem`,
    teaorValue: '471'
  },
  {
    labelText: `4711 '08 Élelmiszer jellegű bolti vegyes kiskereskedelem`,
    teaorValue: '4711'
  },
  {
    labelText: `4719 '08 Iparcikk jellegű bolti vegyes kiskereskedelem`,
    teaorValue: '4719'
  },
  {
    labelText: `472 '08 Élelmiszer-, ital-, dohányáru kiskereskedelme`,
    teaorValue: '472'
  },
  {
    labelText: `4721 '08 Zöldség, gyümölcs kiskereskedelme`,
    teaorValue: '4721'
  },
  {
    labelText: `4722 '08 Hús-, húsáru kiskereskedelme`,
    teaorValue: '4722'
  },
  {
    labelText: `4723 '08 Hal kiskereskedelme`,
    teaorValue: '4723'
  },
  {
    labelText: `4724 '08 Kenyér-, pékáru-, édesség-kiskereskedelem`,
    teaorValue: '4724'
  },
  {
    labelText: `4725 '08 Ital-kiskereskedelem`,
    teaorValue: '4725'
  },
  {
    labelText: `4726 '08 Dohányáru-kiskereskedelem`,
    teaorValue: '4726'
  },
  {
    labelText: `4729 '08 Egyéb élelmiszer-kiskereskedelem`,
    teaorValue: '4729'
  },
  {
    labelText: `473 '08 Gépjárműüzemanyag-kiskereskedelem`,
    teaorValue: '473'
  },
  {
    labelText: `4730 '08 Gépjárműüzemanyag-kiskereskedelem`,
    teaorValue: '4730'
  },
  {
    labelText: `474 '08 Információs, híradás-technikai termék kiskereskedelme`,
    teaorValue: '474'
  },
  {
    labelText: `4741 '08 Számítógép, periféria, szoftver kiskereskedelme`,
    teaorValue: '4741'
  },
  {
    labelText: `4742 '08 Telekommunikációs termék kiskereskedelme`,
    teaorValue: '4742'
  },
  {
    labelText: `4743 '08 Audio-, videoberendezés kiskereskedelme`,
    teaorValue: '4743'
  },
  {
    labelText: `475 '08 Egyéb háztartási cikk kiskereskedelme`,
    teaorValue: '475'
  },
  {
    labelText: `4751 '08 Textil-kiskereskedelem`,
    teaorValue: '4751'
  },
  {
    labelText: `4752 '08 Vasáru-, festék-, üveg-kiskereskedelem`,
    teaorValue: '4752'
  },
  {
    labelText: `4753 '08 Takaró, szőnyeg, fal-, padlóburkoló kiskereskedelme`,
    teaorValue: '4753'
  },
  {
    labelText: `4754 '08 Villamos háztartási készülék kiskereskedelme`,
    teaorValue: '4754'
  },
  {
    labelText: `4759 '08 Bútor, világítási eszköz, egyéb háztartási cikk kiskereskedelme`,
    teaorValue: '4759'
  },
  {
    labelText: `476 '08 Kulturális, szabadidős cikk bolti kiskereskedelme`,
    teaorValue: '476'
  },
  {
    labelText: `4761 '08 Könyv-kiskereskedelem`,
    teaorValue: '4761'
  },
  {
    labelText: `4762 '08 Újság-, papíráru-kiskereskedelem`,
    teaorValue: '4762'
  },
  {
    labelText: `4763 '08 Zene-, videofelvétel kiskereskedelme`,
    teaorValue: '4763'
  },
  {
    labelText: `4764 '08 Sportszer-kiskereskedelem`,
    teaorValue: '4764'
  },
  {
    labelText: `4765 '08 Játék-kiskereskedelem`,
    teaorValue: '4765'
  },
  {
    labelText: `477 '08 Egyéb m`,
    teaorValue: '477'
  },
  {
    labelText: `4771 '08 Ruházat kiskereskedelem`,
    teaorValue: '4771'
  },
  {
    labelText: `4772 '08 Lábbeli-, bőráru-kiskereskedelem`,
    teaorValue: '4772'
  },
  {
    labelText: `4773 '08 Gyógyszer-kiskereskedelem`,
    teaorValue: '4773'
  },
  {
    labelText: `4774 '08 Gyógyászati termék kiskereskedelme`,
    teaorValue: '4774'
  },
  {
    labelText: `4775 '08 Illatszer-kiskereskedelem`,
    teaorValue: '4775'
  },
  {
    labelText: `4776 '08 Dísznövény, vetőmag, műtrágya, hobbiállat-eledel kiskereskedelme`,
    teaorValue: '4776'
  },
  {
    labelText: `4777 '08 Óra-, ékszer-kiskereskedelem`,
    teaorValue: '4777'
  },
  {
    labelText: `4778 '08 Egyéb m`,
    teaorValue: '4778'
  },
  {
    labelText: `4779 '08 Használtcikk bolti kiskereskedelme`,
    teaorValue: '4779'
  },
  {
    labelText: `478 '08 Piaci kiskereskedelem`,
    teaorValue: '478'
  },
  {
    labelText: `4781 '08 Élelmiszer, ital, dohányáru piaci kiskereskedelme`,
    teaorValue: '4781'
  },
  {
    labelText: `4782 '08 Textil, ruházat, lábbeli piaci kiskereskedelme`,
    teaorValue: '4782'
  },
  {
    labelText: `4789 '08 Egyéb áruk piaci kiskereskedelme`,
    teaorValue: '4789'
  },
  {
    labelText: `479 '08 Nem bolti, piaci kiskereskedelem`,
    teaorValue: '479'
  },
  {
    labelText: `4791 '08 Csomagküldő, internetes kiskereskedelem`,
    teaorValue: '4791'
  },
  {
    labelText: `4799 '08 Egyéb nem bolti, piaci kiskereskedelem`,
    teaorValue: '4799'
  },
  {
    labelText: `49 '08 Szárazföldi, csővezetékes szállítás`,
    teaorValue: '49'
  },
  {
    labelText: `491 '08 Helyközi vasúti személyszállítás`,
    teaorValue: '491'
  },
  {
    labelText: `4910 '08 Helyközi vasúti személyszállítás`,
    teaorValue: '4910'
  },
  {
    labelText: `492 '08 Vasúti áruszállítás`,
    teaorValue: '492'
  },
  {
    labelText: `4920 '08 Vasúti áruszállítás`,
    teaorValue: '4920'
  },
  {
    labelText: `493 '08 Egyéb szárazföldi személyszállítás`,
    teaorValue: '493'
  },
  {
    labelText: `4931 '08 Városi, elővárosi szárazföldi személyszállítás`,
    teaorValue: '4931'
  },
  {
    labelText: `4932 '08 Taxis személyszállítás`,
    teaorValue: '4932'
  },
  {
    labelText: `4939 '08 M`,
    teaorValue: '4939'
  },
  {
    labelText: `494 '08 Közúti áruszállítás, költöztetés`,
    teaorValue: '494'
  },
  {
    labelText: `4941 '08 Közúti áruszállítás`,
    teaorValue: '4941'
  },
  {
    labelText: `4942 '08 Költöztetés`,
    teaorValue: '4942'
  },
  {
    labelText: `495 '08 Csővezetékes szállítás`,
    teaorValue: '495'
  },
  {
    labelText: `4950 '08 Csővezetékes szállítás`,
    teaorValue: '4950'
  },
  {
    labelText: `50 '08 Vízi szállítás`,
    teaorValue: '50'
  },
  {
    labelText: `501 '08 Tengeri személyszállítás`,
    teaorValue: '501'
  },
  {
    labelText: `5010 '08 Tengeri személyszállítás`,
    teaorValue: '5010'
  },
  {
    labelText: `502 '08 Tengeri áruszállítás`,
    teaorValue: '502'
  },
  {
    labelText: `5020 '08 Tengeri áruszállítás`,
    teaorValue: '5020'
  },
  {
    labelText: `503 '08 Belvízi személyszállítás`,
    teaorValue: '503'
  },
  {
    labelText: `5030 '08 Belvízi személyszállítás`,
    teaorValue: '5030'
  },
  {
    labelText: `504 '08 Belvízi áruszállítás`,
    teaorValue: '504'
  },
  {
    labelText: `5040 '08 Belvízi áruszállítás`,
    teaorValue: '5040'
  },
  {
    labelText: `51 '08 Légi szállítás`,
    teaorValue: '51'
  },
  {
    labelText: `511 '08 Légi személyszállítás`,
    teaorValue: '511'
  },
  {
    labelText: `5110 '08 Légi személyszállítás`,
    teaorValue: '5110'
  },
  {
    labelText: `512 '08 Légi áruszállítás`,
    teaorValue: '512'
  },
  {
    labelText: `5121 '08 Légi áruszállítás`,
    teaorValue: '5121'
  },
  {
    labelText: `5122 '08 Űrszállítás`,
    teaorValue: '5122'
  },
  {
    labelText: `52 '08 Raktározás, szállítást kiegészítő tevékenység`,
    teaorValue: '52'
  },
  {
    labelText: `521 '08 Raktározás, tárolás`,
    teaorValue: '521'
  },
  {
    labelText: `5210 '08 Raktározás, tárolás`,
    teaorValue: '5210'
  },
  {
    labelText: `522 '08 Szállítást kiegészítő tevékenység`,
    teaorValue: '522'
  },
  {
    labelText: `5221 '08 Szárazföldi szállítást kiegészítő szolgáltatás`,
    teaorValue: '5221'
  },
  {
    labelText: `5222 '08 Vízi szállítást kiegészítő szolgáltatás`,
    teaorValue: '5222'
  },
  {
    labelText: `5223 '08 Légi szállítást kiegészítő szolgáltatás`,
    teaorValue: '5223'
  },
  {
    labelText: `5224 '08 Rakománykezelés`,
    teaorValue: '5224'
  },
  {
    labelText: `5229 '08 Egyéb szállítást kiegészítő szolgáltatás`,
    teaorValue: '5229'
  },
  {
    labelText: `53 '08 Postai, futárpostai tevékenység`,
    teaorValue: '53'
  },
  {
    labelText: `531 '08 Postai tevékenység (egyetemes kötelezettséggel)`,
    teaorValue: '531'
  },
  {
    labelText: `5310 '08 Postai tevékenység (egyetemes kötelezettséggel)`,
    teaorValue: '5310'
  },
  {
    labelText: `532 '08 Egyéb postai, futárpostai tevékenység`,
    teaorValue: '532'
  },
  {
    labelText: `5320 '08 Egyéb postai, futárpostai tevékenység`,
    teaorValue: '5320'
  },
  {
    labelText: `55 '08 Szálláshely-szolgáltatás`,
    teaorValue: '55'
  },
  {
    labelText: `551 '08 Szállodai szolgáltatás`,
    teaorValue: '551'
  },
  {
    labelText: `5510 '08 Szállodai szolgáltatás`,
    teaorValue: '5510'
  },
  {
    labelText: `552 '08 Üdülési, egyéb átmeneti szálláshely-szolgáltatás`,
    teaorValue: '552'
  },
  {
    labelText: `5520 '08 Üdülési, egyéb átmeneti szálláshely-szolgáltatás`,
    teaorValue: '5520'
  },
  {
    labelText: `553 '08 Kempingszolgáltatás`,
    teaorValue: '553'
  },
  {
    labelText: `5530 '08 Kempingszolgáltatás`,
    teaorValue: '5530'
  },
  {
    labelText: `559 '08 Egyéb szálláshely-szolgáltatás`,
    teaorValue: '559'
  },
  {
    labelText: `5590 '08 Egyéb szálláshely-szolgáltatás`,
    teaorValue: '5590'
  },
  {
    labelText: `56 '08 Vendéglátás`,
    teaorValue: '56'
  },
  {
    labelText: `561 '08 Éttermi, mozgó vendéglátás`,
    teaorValue: '561'
  },
  {
    labelText: `5610 '08 Éttermi, mozgó vendéglátás`,
    teaorValue: '5610'
  },
  {
    labelText: `562 '08 Rendezvényi étkeztetés és egyéb vendéglátás`,
    teaorValue: '562'
  },
  {
    labelText: `5621 '08 Rendezvényi étkeztetés`,
    teaorValue: '5621'
  },
  {
    labelText: `5629 '08 Egyéb vendéglátás`,
    teaorValue: '5629'
  },
  {
    labelText: `563 '08 Italszolgáltatás`,
    teaorValue: '563'
  },
  {
    labelText: `5630 '08 Italszolgáltatás`,
    teaorValue: '5630'
  },
  {
    labelText: `58 '08 Kiadói tevékenység`,
    teaorValue: '58'
  },
  {
    labelText: `581 '08 Kiadói tevékenység`,
    teaorValue: '581'
  },
  {
    labelText: `5811 '08 Könyvkiadás`,
    teaorValue: '5811'
  },
  {
    labelText: `5812 '08 Címtárak, levelezőjegyzékek kiadása`,
    teaorValue: '5812'
  },
  {
    labelText: `5813 '08 Napilapkiadás`,
    teaorValue: '5813'
  },
  {
    labelText: `5814 '08 Folyóirat, időszaki kiadvány kiadása`,
    teaorValue: '5814'
  },
  {
    labelText: `5819 '08 Egyéb kiadói tevékenység`,
    teaorValue: '5819'
  },
  {
    labelText: `582 '08 Szoftverkiadás`,
    teaorValue: '582'
  },
  {
    labelText: `5821 '08 Számítógépes játék kiadása`,
    teaorValue: '5821'
  },
  {
    labelText: `5829 '08 Egyéb szoftverkiadás`,
    teaorValue: '5829'
  },
  {
    labelText: `59 '08 Film, video, televízióműsor gyártása, hangfelvétel-kiadás`,
    teaorValue: '59'
  },
  {
    labelText: `591 '08 Film-, video-, televízióműsor-gyártás`,
    teaorValue: '591'
  },
  {
    labelText: `5911 '08 Film-, video-, televízióműsor-gyártás`,
    teaorValue: '5911'
  },
  {
    labelText: `5912 '08 Film-, videogyártás, televíziós műsorfelvétel utómunkálatai`,
    teaorValue: '5912'
  },
  {
    labelText: `5913 '08 Film-, video- és televízióprogram terjesztése`,
    teaorValue: '5913'
  },
  {
    labelText: `5914 '08 Filmvetítés`,
    teaorValue: '5914'
  },
  {
    labelText: `592 '08 Hangfelvétel készítése, kiadása`,
    teaorValue: '592'
  },
  {
    labelText: `5920 '08 Hangfelvétel készítése, kiadása`,
    teaorValue: '5920'
  },
  {
    labelText: `60 '08 Műsorösszeállítás, műsorszolgáltatás`,
    teaorValue: '60'
  },
  {
    labelText: `601 '08 Rádióműsor-szolgáltatás`,
    teaorValue: '601'
  },
  {
    labelText: `6010 '08 Rádióműsor-szolgáltatás`,
    teaorValue: '6010'
  },
  {
    labelText: `602 '08 Televízióműsor összeállítása, szolgáltatása`,
    teaorValue: '602'
  },
  {
    labelText: `6020 '08 Televízióműsor összeállítása, szolgáltatása`,
    teaorValue: '6020'
  },
  {
    labelText: `61 '08 Távközlés`,
    teaorValue: '61'
  },
  {
    labelText: `611 '08 Vezetékes távközlés`,
    teaorValue: '611'
  },
  {
    labelText: `6110 '08 Vezetékes távközlés`,
    teaorValue: '6110'
  },
  {
    labelText: `612 '08 Vezeték nélküli távközlés`,
    teaorValue: '612'
  },
  {
    labelText: `6120 '08 Vezeték nélküli távközlés`,
    teaorValue: '6120'
  },
  {
    labelText: `613 '08 Műholdas távközlés`,
    teaorValue: '613'
  },
  {
    labelText: `6130 '08 Műholdas távközlés`,
    teaorValue: '6130'
  },
  {
    labelText: `619 '08 Egyéb távközlés`,
    teaorValue: '619'
  },
  {
    labelText: `6190 '08 Egyéb távközlés`,
    teaorValue: '6190'
  },
  {
    labelText: `62 '08 Információ-technológiai szolgáltatás`,
    teaorValue: '62'
  },
  {
    labelText: `620 '08 Információ-technológiai szolgáltatás`,
    teaorValue: '620'
  },
  {
    labelText: `6201 '08 Számítógépes programozás`,
    teaorValue: '6201'
  },
  {
    labelText: `6202 '08 Információ-technológiai szaktanácsadás`,
    teaorValue: '6202'
  },
  {
    labelText: `6203 '08 Számítógép-üzemeltetés`,
    teaorValue: '6203'
  },
  {
    labelText: `6209 '08 Egyéb információ-technológiai szolgáltatás`,
    teaorValue: '6209'
  },
  {
    labelText: `63 '08 Információs szolgáltatás`,
    teaorValue: '63'
  },
  {
    labelText: `631 '08 Adatfeldolgozás, web-hoszting, világháló-portál szolgáltatás`,
    teaorValue: '631'
  },
  {
    labelText: `6311 '08 Adatfeldolgozás, web-hoszting szolgáltatás`,
    teaorValue: '6311'
  },
  {
    labelText: `6312 '08 Világháló-portál szolgáltatás`,
    teaorValue: '6312'
  },
  {
    labelText: `639 '08 Egyéb információs szolgáltatás`,
    teaorValue: '639'
  },
  {
    labelText: `6391 '08 Hírügynökségi tevékenység`,
    teaorValue: '6391'
  },
  {
    labelText: `6399 '08 M`,
    teaorValue: '6399'
  },
  {
    labelText: `64 '08 Pénzügyi közvetítés (kivéve: biztosítási, nyugdíjpénztári tevékenység)`,
    teaorValue: '64'
  },
  {
    labelText: `641 '08 Monetáris közvetítés`,
    teaorValue: '641'
  },
  {
    labelText: `6411 '08 Jegybanki tevékenység`,
    teaorValue: '6411'
  },
  {
    labelText: `6419 '08 Egyéb monetáris közvetítés`,
    teaorValue: '6419'
  },
  {
    labelText: `642 '08 Vagyonkezelés (holding)`,
    teaorValue: '642'
  },
  {
    labelText: `6420 '08 Vagyonkezelés (holding)`,
    teaorValue: '6420'
  },
  {
    labelText: `643 '08 Befektetési alapok és hasonlók`,
    teaorValue: '643'
  },
  {
    labelText: `6430 '08 Befektetési alapok és hasonlók`,
    teaorValue: '6430'
  },
  {
    labelText: `649 '08 Egyéb pénzügyi közvetítés`,
    teaorValue: '649'
  },
  {
    labelText: `6491 '08 Pénzügyi lízing`,
    teaorValue: '6491'
  },
  {
    labelText: `6492 '08 Egyéb hitelnyújtás`,
    teaorValue: '6492'
  },
  {
    labelText: `6499 '08 M`,
    teaorValue: '6499'
  },
  {
    labelText: `65 '08 Biztosítás, viszontbiztosítás, nyugdíjalapok (kivéve: kötelező társadalombiztosítás)`,
    teaorValue: '65'
  },
  {
    labelText: `651 '08 Biztosítás`,
    teaorValue: '651'
  },
  {
    labelText: `6511 '08 Életbiztosítás`,
    teaorValue: '6511'
  },
  {
    labelText: `6512 '08 Nem életbiztosítás`,
    teaorValue: '6512'
  },
  {
    labelText: `652 '08 Viszontbiztosítás`,
    teaorValue: '652'
  },
  {
    labelText: `6520 '08 Viszontbiztosítás`,
    teaorValue: '6520'
  },
  {
    labelText: `653 '08 Nyugdíjalapok`,
    teaorValue: '653'
  },
  {
    labelText: `6530 '08 Nyugdíjalapok`,
    teaorValue: '6530'
  },
  {
    labelText: `66 '08 Egyéb pénzügyi tevékenység`,
    teaorValue: '66'
  },
  {
    labelText: `661 '08 Pénzügyi kiegészítő tevékenység (kivéve: biztosítás, nyugdíjalap)`,
    teaorValue: '661'
  },
  {
    labelText: `6611 '08 Pénz-, tőkepiac igazgatása`,
    teaorValue: '6611'
  },
  {
    labelText: `6612 '08 Értékpapír-, árutőzsdei ügynöki tevékenység`,
    teaorValue: '6612'
  },
  {
    labelText: `6619 '08 Egyéb pénzügyi kiegészítő tevékenység`,
    teaorValue: '6619'
  },
  {
    labelText: `662 '08 Biztosítást, nyugdíjalapot kiegészítő tevékenység`,
    teaorValue: '662'
  },
  {
    labelText: `6621 '08 Kockázatértékelés, kárszakértés`,
    teaorValue: '6621'
  },
  {
    labelText: `6622 '08 Biztosítási ügynöki, brókeri tevékenység`,
    teaorValue: '6622'
  },
  {
    labelText: `6629 '08 Biztosítás, nyugdíjalap egyéb kiegészítő tevékenysége`,
    teaorValue: '6629'
  },
  {
    labelText: `663 '08 Alapkezelés`,
    teaorValue: '663'
  },
  {
    labelText: `6630 '08 Alapkezelés`,
    teaorValue: '6630'
  },
  {
    labelText: `68 '08 Ingatlanügyletek`,
    teaorValue: '68'
  },
  {
    labelText: `681 '08 Saját tulajdonú ingatlan adásvétele`,
    teaorValue: '681'
  },
  {
    labelText: `6810 '08 Saját tulajdonú ingatlan adásvétele`,
    teaorValue: '6810'
  },
  {
    labelText: `682 '08 Saját tulajdonú, bérelt ingatlan bérbeadása, üzemeltetése`,
    teaorValue: '682'
  },
  {
    labelText: `6820 '08 Saját tulajdonú, bérelt ingatlan bérbeadása, üzemeltetése`,
    teaorValue: '6820'
  },
  {
    labelText: `683 '08 Ingatlanügynöki, -kezelési szolgáltatás`,
    teaorValue: '683'
  },
  {
    labelText: `6831 '08 Ingatlanügynöki tevékenység`,
    teaorValue: '6831'
  },
  {
    labelText: `6832 '08 Ingatlankezelés`,
    teaorValue: '6832'
  },
  {
    labelText: `69 '08 Jogi, számviteli, adószakértői tevékenység`,
    teaorValue: '69'
  },
  {
    labelText: `691 '08 Jogi tevékenység`,
    teaorValue: '691'
  },
  {
    labelText: `6910 '08 Jogi tevékenység`,
    teaorValue: '6910'
  },
  {
    labelText: `692 '08 Számviteli, könyvvizsgálói, adószakértői tevékenység`,
    teaorValue: '692'
  },
  {
    labelText: `6920 '08 Számviteli, könyvvizsgálói, adószakértői tevékenység`,
    teaorValue: '6920'
  },
  {
    labelText: `70 '08 Üzletvezetési, vezetői tanácsadás`,
    teaorValue: '70'
  },
  {
    labelText: `701 '08 Üzletvezetés`,
    teaorValue: '701'
  },
  {
    labelText: `7010 '08 Üzletvezetés`,
    teaorValue: '7010'
  },
  {
    labelText: `702 '08 Üzletviteli tanácsadás`,
    teaorValue: '702'
  },
  {
    labelText: `7021 '08 PR, kommunikáció`,
    teaorValue: '7021'
  },
  {
    labelText: `7022 '08 Üzletviteli, egyéb vezetési tanácsadás`,
    teaorValue: '7022'
  },
  {
    labelText: `71 '08 Építészmérnöki tevékenység; műszaki vizsgálat, elemzés`,
    teaorValue: '71'
  },
  {
    labelText: `711 '08 Építészmérnöki tevékenység; műszaki vizsgálat, elemzés`,
    teaorValue: '711'
  },
  {
    labelText: `7111 '08 Építészmérnöki tevékenység`,
    teaorValue: '7111'
  },
  {
    labelText: `7112 '08 Mérnöki tevékenység, műszaki tanácsadás`,
    teaorValue: '7112'
  },
  {
    labelText: `712 '08 Műszaki vizsgálat, elemzés`,
    teaorValue: '712'
  },
  {
    labelText: `7120 '08 Műszaki vizsgálat, elemzés`,
    teaorValue: '7120'
  },
  {
    labelText: `72 '08 Tudományos kutatás, fejlesztés`,
    teaorValue: '72'
  },
  {
    labelText: `721 '08 Természettudományi, műszaki kutatás, fejlesztés`,
    teaorValue: '721'
  },
  {
    labelText: `7211 '08 Biotechnológiai kutatás, fejlesztés`,
    teaorValue: '7211'
  },
  {
    labelText: `7219 '08 Egyéb természettudományi, műszaki kutatás, fejlesztés`,
    teaorValue: '7219'
  },
  {
    labelText: `722 '08 Társadalomtudományi, humán kutatás, fejlesztés`,
    teaorValue: '722'
  },
  {
    labelText: `7220 '08 Társadalomtudományi, humán kutatás, fejlesztés`,
    teaorValue: '7220'
  },
  {
    labelText: `73 '08 Reklám, piackutatás`,
    teaorValue: '73'
  },
  {
    labelText: `731 '08 Reklám`,
    teaorValue: '731'
  },
  {
    labelText: `7311 '08 Reklámügynöki tevékenység`,
    teaorValue: '7311'
  },
  {
    labelText: `7312 '08 Médiareklám`,
    teaorValue: '7312'
  },
  {
    labelText: `732 '08 Piac-, közvélemény-kutatás`,
    teaorValue: '732'
  },
  {
    labelText: `7320 '08 Piac-, közvélemény-kutatás`,
    teaorValue: '7320'
  },
  {
    labelText: `74 '08 Egyéb szakmai, tudományos, műszaki tevékenység`,
    teaorValue: '74'
  },
  {
    labelText: `741 '08 Divat-, formatervezés`,
    teaorValue: '741'
  },
  {
    labelText: `7410 '08 Divat-, formatervezés`,
    teaorValue: '7410'
  },
  {
    labelText: `742 '08 Fényképészet`,
    teaorValue: '742'
  },
  {
    labelText: `7420 '08 Fényképészet`,
    teaorValue: '7420'
  },
  {
    labelText: `743 '08 Fordítás, tolmácsolás`,
    teaorValue: '743'
  },
  {
    labelText: `7430 '08 Fordítás, tolmácsolás`,
    teaorValue: '7430'
  },
  {
    labelText: `749 '08 M`,
    teaorValue: '749'
  },
  {
    labelText: `7490 '08 M`,
    teaorValue: '7490'
  },
  {
    labelText: `75 '08 Állat-egészségügyi ellátás`,
    teaorValue: '75'
  },
  {
    labelText: `750 '08 Állat-egészségügyi ellátás`,
    teaorValue: '750'
  },
  {
    labelText: `7500 '08 Állat-egészségügyi ellátás`,
    teaorValue: '7500'
  },
  {
    labelText: `77 '08 Kölcsönzés, operatív lízing`,
    teaorValue: '77'
  },
  {
    labelText: `771 '08 Gépjárműkölcsönzés`,
    teaorValue: '771'
  },
  {
    labelText: `7711 '08 Személygépjármű kölcsönzése`,
    teaorValue: '7711'
  },
  {
    labelText: `7712 '08 Gépjárműkölcsönzés (3,5 tonna fölött)`,
    teaorValue: '7712'
  },
  {
    labelText: `772 '08 Személyi használatú, háztartási cikk kölcsönzése`,
    teaorValue: '772'
  },
  {
    labelText: `7721 '08 Szabadidős, sporteszköz kölcsönzése`,
    teaorValue: '7721'
  },
  {
    labelText: `7722 '08 Videokazetta, lemez kölcsönzése`,
    teaorValue: '7722'
  },
  {
    labelText: `7729 '08 Egyéb személyi használatú, háztartási cikk kölcsönzése`,
    teaorValue: '7729'
  },
  {
    labelText: `773 '08 Egyéb gép, tárgyi eszköz kölcsönzése`,
    teaorValue: '773'
  },
  {
    labelText: `7731 '08 Mezőgazdasági gép kölcsönzése`,
    teaorValue: '7731'
  },
  {
    labelText: `7732 '08 Építőipari gép kölcsönzése`,
    teaorValue: '7732'
  },
  {
    labelText: `7733 '08 Irodagép kölcsönzése (beleértve: számítógép)`,
    teaorValue: '7733'
  },
  {
    labelText: `7734 '08 Vízi szállítóeszköz kölcsönzése`,
    teaorValue: '7734'
  },
  {
    labelText: `7735 '08 Légi szállítóeszköz kölcsönzése`,
    teaorValue: '7735'
  },
  {
    labelText: `7739 '08 Egyéb gép, tárgyi eszköz kölcsönzése`,
    teaorValue: '7739'
  },
  {
    labelText: `774 '08 Immateriális javak kölcsönzése`,
    teaorValue: '774'
  },
  {
    labelText: `7740 '08 Immateriális javak kölcsönzése`,
    teaorValue: '7740'
  },
  {
    labelText: `78 '08 Munkaerőpiaci szolgáltatás`,
    teaorValue: '78'
  },
  {
    labelText: `781 '08 Munkaközvetítés`,
    teaorValue: '781'
  },
  {
    labelText: `7810 '08 Munkaközvetítés`,
    teaorValue: '7810'
  },
  {
    labelText: `782 '08 Munkaerőkölcsönzés`,
    teaorValue: '782'
  },
  {
    labelText: `7820 '08 Munkaerőkölcsönzés`,
    teaorValue: '7820'
  },
  {
    labelText: `783 '08 Egyéb emberierőforrás-ellátás, -gazdálkodás`,
    teaorValue: '783'
  },
  {
    labelText: `7830 '08 Egyéb emberierőforrás-ellátás, -gazdálkodás`,
    teaorValue: '7830'
  },
  {
    labelText: `79 '08 Utazásközvetítés, utazásszervezés, egyéb foglalás`,
    teaorValue: '79'
  },
  {
    labelText: `791 '08 Utazásközvetítés, utazásszervezés`,
    teaorValue: '791'
  },
  {
    labelText: `7911 '08 Utazásközvetítés`,
    teaorValue: '7911'
  },
  {
    labelText: `7912 '08 Utazásszervezés`,
    teaorValue: '7912'
  },
  {
    labelText: `799 '08 Egyéb foglalás`,
    teaorValue: '799'
  },
  {
    labelText: `7990 '08 Egyéb foglalás`,
    teaorValue: '7990'
  },
  {
    labelText: `80 '08 Biztonsági, nyomozói tevékenység`,
    teaorValue: '80'
  },
  {
    labelText: `801 '08 Személybiztonsági tevékenység`,
    teaorValue: '801'
  },
  {
    labelText: `8010 '08 Személybiztonsági tevékenység`,
    teaorValue: '8010'
  },
  {
    labelText: `802 '08 Biztonsági rendszer szolgáltatás`,
    teaorValue: '802'
  },
  {
    labelText: `8020 '08 Biztonsági rendszer szolgáltatás`,
    teaorValue: '8020'
  },
  {
    labelText: `803 '08 Nyomozás`,
    teaorValue: '803'
  },
  {
    labelText: `8030 '08 Nyomozás`,
    teaorValue: '8030'
  },
  {
    labelText: `81 '08 Építményüzemeltetés, zöldterület-kezelés`,
    teaorValue: '81'
  },
  {
    labelText: `811 '08 Építményüzemeltetés`,
    teaorValue: '811'
  },
  {
    labelText: `8110 '08 Építményüzemeltetés`,
    teaorValue: '8110'
  },
  {
    labelText: `812 '08 Takarítás`,
    teaorValue: '812'
  },
  {
    labelText: `8121 '08 Általános épülettakarítás`,
    teaorValue: '8121'
  },
  {
    labelText: `8122 '08 Egyéb épület-, ipari takarítás`,
    teaorValue: '8122'
  },
  {
    labelText: `8129 '08 Egyéb takarítás`,
    teaorValue: '8129'
  },
  {
    labelText: `813 '08 Zöldterület-kezelés`,
    teaorValue: '813'
  },
  {
    labelText: `8130 '08 Zöldterület-kezelés`,
    teaorValue: '8130'
  },
  {
    labelText: `82 '08 Adminisztratív, kiegészítő egyéb üzleti szolgáltatás`,
    teaorValue: '82'
  },
  {
    labelText: `821 '08 Adminisztratív, kiegészítő szolgáltatás`,
    teaorValue: '821'
  },
  {
    labelText: `8211 '08 Összetett adminisztratív szolgáltatás`,
    teaorValue: '8211'
  },
  {
    labelText: `8219 '08 Fénymásolás, egyéb irodai szolgáltatás`,
    teaorValue: '8219'
  },
  {
    labelText: `822 '08 Telefoninformáció`,
    teaorValue: '822'
  },
  {
    labelText: `8220 '08 Telefoninformáció`,
    teaorValue: '8220'
  },
  {
    labelText: `823 '08 Konferencia, kereskedelmi bemutató szervezése`,
    teaorValue: '823'
  },
  {
    labelText: `8230 '08 Konferencia, kereskedelmi bemutató szervezése`,
    teaorValue: '8230'
  },
  {
    labelText: `829 '08 Egyéb kiegészítő gazdasági tevékenység`,
    teaorValue: '829'
  },
  {
    labelText: `8291 '08 Követelésbehajtás`,
    teaorValue: '8291'
  },
  {
    labelText: `8292 '08 Csomagolás`,
    teaorValue: '8292'
  },
  {
    labelText: `8299 '08 M`,
    teaorValue: '8299'
  },
  {
    labelText: `84 '08 Közigazgatás, védelem; kötelező társadalombiztosítás`,
    teaorValue: '84'
  },
  {
    labelText: `841 '08 Közigazgatás`,
    teaorValue: '841'
  },
  {
    labelText: `8411 '08 Általános közigazgatás`,
    teaorValue: '8411'
  },
  {
    labelText: `8412 '08 Egészségügy, oktatás, kultúra, egyéb szociális szolgáltatás (kivéve: társadalombiztosítás) igazgatása`,
    teaorValue: '8412'
  },
  {
    labelText: `8413 '08 Üzleti élet szabályozása, hatékonyságának ösztönzése`,
    teaorValue: '8413'
  },
  {
    labelText: `842 '08 Társadalmi közszolgáltatás`,
    teaorValue: '842'
  },
  {
    labelText: `8421 '08 Külügyek`,
    teaorValue: '8421'
  },
  {
    labelText: `8422 '08 Honvédelem`,
    teaorValue: '8422'
  },
  {
    labelText: `8423 '08 Igazságügy, bíróság`,
    teaorValue: '8423'
  },
  {
    labelText: `8424 '08 Közbiztonság, közrend`,
    teaorValue: '8424'
  },
  {
    labelText: `8425 '08 Tűzvédelem`,
    teaorValue: '8425'
  },
  {
    labelText: `843 '08 Kötelező társadalombiztosítás`,
    teaorValue: '843'
  },
  {
    labelText: `8430 '08 Kötelező társadalombiztosítás`,
    teaorValue: '8430'
  },
  {
    labelText: `85 '08 Oktatás`,
    teaorValue: '85'
  },
  {
    labelText: `851 '08 Iskolai előkészítő oktatás`,
    teaorValue: '851'
  },
  {
    labelText: `8510 '08 Iskolai előkészítő oktatás`,
    teaorValue: '8510'
  },
  {
    labelText: `852 '08 Alapfokú oktatás`,
    teaorValue: '852'
  },
  {
    labelText: `8520 '08 Alapfokú oktatás`,
    teaorValue: '8520'
  },
  {
    labelText: `853 '08 Középfokú oktatás`,
    teaorValue: '853'
  },
  {
    labelText: `8531 '08 Általános középfokú oktatás`,
    teaorValue: '8531'
  },
  {
    labelText: `8532 '08 Szakmai középfokú oktatás`,
    teaorValue: '8532'
  },
  {
    labelText: `854 '08 Felső szintű oktatás`,
    teaorValue: '854'
  },
  {
    labelText: `8541 '08 Felső szintű, nem felsőfokú oktatás`,
    teaorValue: '8541'
  },
  {
    labelText: `8542 '08 Felsőfokú oktatás`,
    teaorValue: '8542'
  },
  {
    labelText: `855 '08 Egyéb oktatás`,
    teaorValue: '855'
  },
  {
    labelText: `8551 '08 Sport, szabadidős képzés`,
    teaorValue: '8551'
  },
  {
    labelText: `8552 '08 Kulturális képzés`,
    teaorValue: '8552'
  },
  {
    labelText: `8553 '08 Járművezető-oktatás`,
    teaorValue: '8553'
  },
  {
    labelText: `8559 '08 M`,
    teaorValue: '8559'
  },
  {
    labelText: `856 '08 Oktatást kiegészítő tevékenység`,
    teaorValue: '856'
  },
  {
    labelText: `8560 '08 Oktatást kiegészítő tevékenység`,
    teaorValue: '8560'
  },
  {
    labelText: `86 '08 Humán-egészségügyi ellátás`,
    teaorValue: '86'
  },
  {
    labelText: `861 '08 Fekvőbeteg-ellátás`,
    teaorValue: '861'
  },
  {
    labelText: `8610 '08 Fekvőbeteg-ellátás`,
    teaorValue: '8610'
  },
  {
    labelText: `862 '08 Járóbeteg-ellátás, fogorvosi ellátás`,
    teaorValue: '862'
  },
  {
    labelText: `8621 '08 Általános járóbeteg-ellátás`,
    teaorValue: '8621'
  },
  {
    labelText: `8622 '08 Szakorvosi járóbeteg-ellátás`,
    teaorValue: '8622'
  },
  {
    labelText: `8623 '08 Fogorvosi járóbeteg-ellátás`,
    teaorValue: '8623'
  },
  {
    labelText: `869 '08 Egyéb humán-egészségügyi ellátás`,
    teaorValue: '869'
  },
  {
    labelText: `8690 '08 Egyéb humán-egészségügyi ellátás`,
    teaorValue: '8690'
  },
  {
    labelText: `87 '08 Bentlakásos, nem kórházi ápolás`,
    teaorValue: '87'
  },
  {
    labelText: `871 '08 Bentlakásos, nem kórházi ápolás`,
    teaorValue: '871'
  },
  {
    labelText: `8710 '08 Bentlakásos, nem kórházi ápolás`,
    teaorValue: '8710'
  },
  {
    labelText: `872 '08 Mentális, szenvedélybeteg bentlakásos ellátása`,
    teaorValue: '872'
  },
  {
    labelText: `8720 '08 Mentális, szenvedélybeteg bentlakásos ellátása`,
    teaorValue: '8720'
  },
  {
    labelText: `873 '08 Idősek, fogyatékosok bentlakásos ellátása`,
    teaorValue: '873'
  },
  {
    labelText: `8730 '08 Idősek, fogyatékosok bentlakásos ellátása`,
    teaorValue: '8730'
  },
  {
    labelText: `879 '08 Egyéb bentlakásos ellátás`,
    teaorValue: '879'
  },
  {
    labelText: `8790 '08 Egyéb bentlakásos ellátás`,
    teaorValue: '8790'
  },
  {
    labelText: `88 '08 Szociális ellátás bentlakás nélkül`,
    teaorValue: '88'
  },
  {
    labelText: `881 '08 Idősek, fogyatékosok szociális ellátása bentlakás nélkül`,
    teaorValue: '881'
  },
  {
    labelText: `8810 '08 Idősek, fogyatékosok szociális ellátása bentlakás nélkül`,
    teaorValue: '8810'
  },
  {
    labelText: `889 '08 Egyéb szociális ellátás bentlakás nélkül`,
    teaorValue: '889'
  },
  {
    labelText: `8891 '08 Gyermekek napközbeni ellátása`,
    teaorValue: '8891'
  },
  {
    labelText: `8899 '08 M`,
    teaorValue: '8899'
  },
  {
    labelText: `90 '08 Alkotó-, művészeti, szórakoztató tevékenység`,
    teaorValue: '90'
  },
  {
    labelText: `900 '08 Alkotó-, művészeti, szórakoztató tevékenység`,
    teaorValue: '900'
  },
  {
    labelText: `9001 '08 Előadó-művészet`,
    teaorValue: '9001'
  },
  {
    labelText: `9002 '08 Előadó-művészetet kiegészítő tevékenység`,
    teaorValue: '9002'
  },
  {
    labelText: `9003 '08 Alkotóművészet`,
    teaorValue: '9003'
  },
  {
    labelText: `9004 '08 Művészeti létesítmények működtetése`,
    teaorValue: '9004'
  },
  {
    labelText: `91 '08 Könyvtári, levéltári, múzeumi, egyéb kulturális tevékenység`,
    teaorValue: '91'
  },
  {
    labelText: `910 '08 Könyvtári, levéltári, múzeumi, egyéb kulturális tevékenység`,
    teaorValue: '910'
  },
  {
    labelText: `9101 '08 Könyvtári, levéltári tevékenység`,
    teaorValue: '9101'
  },
  {
    labelText: `9102 '08 Múzeumi tevékenység`,
    teaorValue: '9102'
  },
  {
    labelText: `9103 '08 Történelmi hely, építmény, egyéb látványosság működtetése`,
    teaorValue: '9103'
  },
  {
    labelText: `9104 '08 Növény-, állatkert, természetvédelmi terület működtetése`,
    teaorValue: '9104'
  },
  {
    labelText: `92 '08 Szerencsejáték, fogadás`,
    teaorValue: '92'
  },
  {
    labelText: `920 '08 Szerencsejáték, fogadás`,
    teaorValue: '920'
  },
  {
    labelText: `9200 '08 Szerencsejáték, fogadás`,
    teaorValue: '9200'
  },
  {
    labelText: `93 '08 Sport-, szórakoztató, szabadidős tevékenység`,
    teaorValue: '93'
  },
  {
    labelText: `931 '08 Sporttevékenység`,
    teaorValue: '931'
  },
  {
    labelText: `9311 '08 Sportlétesítmény működtetése`,
    teaorValue: '9311'
  },
  {
    labelText: `9312 '08 Sportegyesületi tevékenység`,
    teaorValue: '9312'
  },
  {
    labelText: `9313 '08 Testedzési szolgáltatás`,
    teaorValue: '9313'
  },
  {
    labelText: `9319 '08 Egyéb sporttevékenység`,
    teaorValue: '9319'
  },
  {
    labelText: `932 '08 Egyéb szórakoztatás, szabadidős tevékenység`,
    teaorValue: '932'
  },
  {
    labelText: `9321 '08 Vidámparki, szórakoztatóparki tevékenység`,
    teaorValue: '9321'
  },
  {
    labelText: `9329 '08 M`,
    teaorValue: '9329'
  },
  {
    labelText: `94 '08 Érdekképviselet`,
    teaorValue: '94'
  },
  {
    labelText: `941 '08 Vállalkozói, szakmai érdekképviselet`,
    teaorValue: '941'
  },
  {
    labelText: `9411 '08 Vállalkozói, munkaadói érdekképviselet`,
    teaorValue: '9411'
  },
  {
    labelText: `9412 '08 Szakmai érdekképviselet`,
    teaorValue: '9412'
  },
  {
    labelText: `942 '08 Szakszervezeti tevékenység`,
    teaorValue: '942'
  },
  {
    labelText: `9420 '08 Szakszervezeti tevékenység`,
    teaorValue: '9420'
  },
  {
    labelText: `949 '08 Egyéb közösségi, társadalmi tevékenység`,
    teaorValue: '949'
  },
  {
    labelText: `9491 '08 Egyházi tevékenység`,
    teaorValue: '9491'
  },
  {
    labelText: `9492 '08 Politikai tevékenység`,
    teaorValue: '9492'
  },
  {
    labelText: `9499 '08 M`,
    teaorValue: '9499'
  },
  {
    labelText: `95 '08 Számítógép, személyi, háztartási cikk javítása`,
    teaorValue: '95'
  },
  {
    labelText: `951 '08 Számítógép, kommunikációs eszköz javítása`,
    teaorValue: '951'
  },
  {
    labelText: `9511 '08 Számítógép, -periféria javítása`,
    teaorValue: '9511'
  },
  {
    labelText: `9512 '08 Kommunikációs eszköz javítása`,
    teaorValue: '9512'
  },
  {
    labelText: `952 '08 Személyi, háztartási cikk javítása`,
    teaorValue: '952'
  },
  {
    labelText: `9521 '08 Szórakoztatóelektronikai cikk javítása`,
    teaorValue: '9521'
  },
  {
    labelText: `9522 '08 Háztartási gép, háztartási, kerti eszköz javítása`,
    teaorValue: '9522'
  },
  {
    labelText: `9523 '08 Lábbeli, egyéb bőráru javítása`,
    teaorValue: '9523'
  },
  {
    labelText: `9524 '08 Bútor, lakberendezési tárgy javítása`,
    teaorValue: '9524'
  },
  {
    labelText: `9525 '08 Óra-, ékszerjavítás`,
    teaorValue: '9525'
  },
  {
    labelText: `9529 '08 Egyéb személyi-, háztartási cikk javítása`,
    teaorValue: '9529'
  },
  {
    labelText: `96 '08 Egyéb személyi szolgáltatás`,
    teaorValue: '96'
  },
  {
    labelText: `960 '08 Egyéb személyi szolgáltatás`,
    teaorValue: '960'
  },
  {
    labelText: `9601 '08 Textil, szőrme mosása, tisztítása`,
    teaorValue: '9601'
  },
  {
    labelText: `9602 '08 Fodrászat, szépségápolás`,
    teaorValue: '9602'
  },
  {
    labelText: `9603 '08 Temetkezés, temetkezést kiegészítő szolgáltatás`,
    teaorValue: '9603'
  },
  {
    labelText: `9604 '08 Fizikai közérzetet javító szolgáltatás`,
    teaorValue: '9604'
  },
  {
    labelText: `9609 '08 M`,
    teaorValue: '9609'
  },
  {
    labelText: `97 '08 Háztartási alkalmazottat foglalkoztató magánháztartás`,
    teaorValue: '97'
  },
  {
    labelText: `970 '08 Háztartási alkalmazottat foglalkoztató magánháztartás`,
    teaorValue: '970'
  },
  {
    labelText: `9700 '08 Háztartási alkalmazottat foglalkoztató magánháztartás`,
    teaorValue: '9700'
  },
  {
    labelText: `98 '08 Háztartás termék-előállítása, szolgáltatása saját fogyasztásra`,
    teaorValue: '98'
  },
  {
    labelText: `981 '08 Háztartás termék-előállítása, szolgáltatása saját fogyasztásra`,
    teaorValue: '981'
  },
  {
    labelText: `9810 '08 Háztartás termék-előállítása, szolgáltatása saját fogyasztásra`,
    teaorValue: '9810'
  },
  {
    labelText: `982 '08 Háztartás szolgáltatása saját fogyasztásra`,
    teaorValue: '982'
  },
  {
    labelText: `9820 '08 Háztartás szolgáltatása saját fogyasztásra`,
    teaorValue: '9820'
  },
  {
    labelText: `99 '08 Területen kívüli szervezet`,
    teaorValue: '99'
  },
  {
    labelText: `990 '08 Területen kívüli szervezet`,
    teaorValue: '990'
  },
  {
    labelText: `9900 '08 Területen kívüli szervezet`,
    teaorValue: '9900'
  }
]

export default teaorList
